/* eslint-disable vue/no-async-in-computed-properties */
/* eslint-disable camelcase */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import Store from 'src/store';
import { get, isEqual, startCase, cloneDeep, omit, sortBy, orderBy, camelCase } from 'lodash';
import { invokeOrIdentity, invokeOrUndefined, invokeOrVoid, rowIsValid } from '../../utils';
import TreeLookup from 'src/components/LookupDialogs/TreeLookup/TreeLookup.vue';
import MainLookupDialog from '../LookupDialogs/MainLookupDialog.vue';
import getValue from './utils/getValue';
import getDisplayValue from './utils/getDisplayValue';
import getColReferenceDataArray from './utils/getColReferenceDataArray';
import openValueSelectorDialog from './utils/openValueSelectorDialog';
import ViewCodeDialog from '../ViewCodeDialog';
import EditHTMLDialog from '../HtmlEditors/EditHTMLDialog';
import DisplayFormatSelector from 'src/components/DisplayFormatSelector/DisplayFormatSelector.vue';
import Card from '../Card/Card.vue';
import highlighter from '../../utils/highlighter.js';
import RecordCard from './RecordCard/RecordCard.vue';
import { encrypt } from '../../utils/encryption/encrypt';
import getOptionValue from 'src/store/preferences/getOptionValue';
import setOptionValue from 'src/store/preferences/setOptionValue';
import { addDays, parseISO, formatISO, addWeeks, addMonths, addQuarters, addYears, startOfWeek, startOfMonth, endOfWeek, endOfMonth } from 'src/utils/dateOperations/date-fns';
import { getRowStyles, getCellContentStyles, getCellContentClasses, getTdStyles, getCellDivClasses, getCellDivStyles } from './utils/gettersOfCalculatedStylesAndClasses';
import getCssPropertiesFromAmbiguousStyleInput from './utils/getCssPropertiesFromAmbiguousStyleInput';
import { fromPgToLocalSorting, fromColumnToStrictColumn } from '../../types';
import datesAreEqual from '../../utils/dateOperations/datesAreEqual';
import dateAIsAfterB from '../../utils/dateOperations/dateAIsAfterB';
import dateAIsBeforeB from '../../utils/dateOperations/dateAIsBeforeB';
import dateAIsGreaterThanOrEqualToB from '../../utils/dateOperations/dateAIsGreaterThanOrEqualToB';
import createRecords from '../../utils/entityOperations/createRecords';
import fileUploadHandler from './utils/fileUploadHandler';
import transformFilterModelFromV0ToV1IfNotYet from 'src/utils/apiVersionConverters/filterModel/transformFilterModelFromV0ToV1IfNotYet';
import transformFilterModelFromV1ToV0IfNotYet from 'src/utils/apiVersionConverters/filterModel/transformFilterModelFromV1ToV0IfNotYet';
import transformSimpleFilterToFilterModelV0 from 'src/utils/apiVersionConverters/filterModel/transformSimpleFilterToFilterModelV0';
import deepmerge from 'deepmerge';
import debounce from 'quasar/src/utils/debounce.js';;
import fetchRecords from 'src/utils/entityOperations/fetchRecords';
import updateRecords from 'src/utils/entityOperations/updateRecords';
import arraysDoOverlap from 'src/utils/arrayOperations/arraysOverlap';
import callRefFunc from 'src/utils/callRefFunc';
import downloadHTMLElementAsPng from 'src/utils/downloadHTMLElementAsPng';
import getter from 'src/utils/entityOperations/getter';
import { todayMinus7Days, todayMinus30Days, tomorrow, getToday, getTomorrow } from 'src/utils/dateOperations/getISODateText';
import getSessionContext from 'src/utils/context/getSessionContext';
import TopSlot from './components/TopSlot';
import HeaderSlot from './components/HeaderSlot';
import BodySlot from './components/BodySlot';
import BottomSlot from './components/BottomSlot';
import fullScreenLoading from 'src/utils/fullScreenLoading';
import repeatLastFetch from 'src/utils/entityOperations/repeatLastFetch';
import transformFilterModelFromV1ToV0 from 'src/utils/apiVersionConverters/filterModel/transformFilterModelFromV1ToV0';
import setCurrentMode from 'src/utils/currentMode/setCurrentMode';
import getRecords from 'src/utils/entityOperations/getRecords';
import setRecords from 'src/utils/entityOperations/setRecords';
import arrayHasElements from 'src/utils/arrayOperations/arrayHasMembers';
import SaveTableViewDialog from 'src/store/meta/table_views/SaveTableViewDialog.vue';
import notUndefined from 'src/utils/filterFunctions/notUndefined';
import not from 'src/utils/filterFunctions/not';
import getEntityDefaultRecordCreateComponent from 'src/utils/entityOperations/propertyGetters/getEntityDefaultRecordCreateComponent';
import getCurrentMode from 'src/utils/currentMode/getCurrentMode';
import GenericTableInternalsViewer from './components/GenericTableInternalsViewer.vue';
import isDebugging from 'src/utils/developer/isDebugging';
import toggleItemPresenceInArray from 'src/utils/arrayOperations/toggleItemPresenceInArray';
import ensureArray from 'src/utils/arrayOperations/ensureArray';
import getColumns from 'src/utils/entityOperations/columns/getColumns';
import dateToISODateTime from 'src/utils/dateOperations/dateToISODateTime';
import dateToISODate from 'src/utils/dateOperations/dateToISODate';
import startOfYear from 'src/utils/dateOperations/date-fns/startOfYear';
import endOfYear from 'src/utils/dateOperations/date-fns/endOfYear';
import startOfQuarter from 'src/utils/dateOperations/date-fns/startOfQuarter';
import endOfQuarter from 'src/utils/dateOperations/date-fns/endOfQuarter';
import product from 'src/utils/arrayOperations/product';
import arrayLength from 'src/utils/arrayOperations/arrayLength';
const getValueFromEnrichedData = (col, row) => {
    const { name = -1, field = -1 } = col;
    if (row[name + '_value'] !== undefined) {
        return row[name + '_value'];
    }
    else if (row[name] !== undefined) {
        return row[name];
    }
    else if (row[field] !== undefined) {
        return row[field];
    }
    else {
        return '';
    }
};
const getDisplayValueFromEnrichedData = (col, row) => row[col.name + '_display_value'] || row[col.name] || row[col.field] || '';
const downloadOptions = [
    { value: 'Human readable', label: 'Human readable (you likely want this)' },
    { value: 'Database readable', label: 'Database readable' },
    { value: 'Both human readable and database readable', label: 'Both human readable and database readable' }
];
const setColumnVisible = (column) => {
    const col = cloneDeep(column);
    if (col.hideWhenDisplaying)
        col.hideWhenDisplaying = false;
    if (col.hideWhenDisplayingInTable)
        col.hideWhenDisplayingInTable = false;
    return col;
};
const setColumnNotVisible = (column) => {
    const col = cloneDeep(column);
    if (col.hideWhenDisplaying !== undefined)
        col.hideWhenDisplaying = true;
    if (col.hideWhenDisplayingInTable !== undefined)
        col.hideWhenDisplayingInTable = true;
    return col;
};
const setColumnVisibility = (col, isVisible) => {
    return isVisible ? setColumnVisible(col) : setColumnNotVisible(col);
};
export default Vue.extend({
    name: 'GenericTable',
    components: { GenericTableInternalsViewer, TopSlot, HeaderSlot, BodySlot, BottomSlot, TreeLookup, MainLookupDialog, ViewCodeDialog, Card, RecordCard, EditHTMLDialog, DisplayFormatSelector, SaveTableViewDialog },
    // when adding props, remember to added combining of component-passed props and props passed from entity definition. see Mark 20210716
    props: {
        stylesToMixInProp: { type: String },
        tableIdProp: { type: String },
        dataProp: { type: Array },
        dataGetter_prop: { type: Function },
        dataGetterResultHandler_prop: { type: Function },
        initialDataProp: { type: [Function, Array] },
        localEntityNameProp: { type: String },
        filtersProp: { type: [Function, Object] },
        columnsProp: { type: Array },
        title: { type: String },
        subTitle: { type: String },
        hideRowDeleteButton: { type: Boolean },
        hideRowViewButton: { type: Boolean },
        hideRowSelectorButton: { type: Boolean },
        hideCreateButton: { type: Boolean },
        hideFiltersAreSetButton: { type: Boolean },
        createRecordShortcutDisabled: { type: Boolean },
        hideUploadListButton: { type: Boolean },
        hideRefreshButton: { type: Boolean },
        hideSaveViewButton: { type: Boolean },
        hideDownloadListButton: { type: Boolean },
        hideTakeSnapshotButton: { type: Boolean },
        hideFullscreenButton: { type: Boolean },
        hideColumnSelectorButton: { type: Boolean },
        hideSortingModelButton: { type: Boolean },
        initialRowsPerPageProp: { type: Number },
        showGrandTotalsRowProp: { type: Boolean },
        showTotalsRowProp: { type: Boolean },
        updatingRecordsIsEnabledProp: { type: Boolean },
        updatingRecordsIsDisabledProp: { type: Boolean },
        creatingRecordsIsEnabledProp: { type: Boolean },
        creatingRecordsIsDisabledProp: { type: Boolean },
        hideTitleProp: { type: Boolean },
        hideHeaderSlotProp: { type: Boolean },
        hideTopSlotProp: { type: Boolean },
        hideBottomSlotProp: { type: Boolean },
        draggableSortableProp: { type: Boolean },
        suppressDraggableSortableProp: { type: Boolean },
        showAddButtonWhenDataIsEmptyProp: { type: Boolean },
        createByAddingRowProp: { type: Boolean },
        isChildTableProp: { type: Boolean },
        columnsToHideProp: { type: Array },
        startingSortingModelProp: { type: Array },
        startingFilterModelProp: { type: Array },
        requestedChangesToDataDisplayProp: { type: Object },
        permanentInvisibleToUserFilterModelProp: { type: Array },
        actionArgumentsProp: { type: Array },
        permanentSortingModelProp: { type: Object },
        controlledActionsProp: { type: Object },
        initiationOfRecordCreationHandlerProp: { type: Function },
        rowIsLockedFunctionProp: { type: Function },
        topRightCornerButtonsZoomProp: { type: Number },
        parentRecordProp: { type: Object },
        doNotFetchDataProp: { type: Boolean },
        forceShowingRowSelectorRegardlessOfColumnsDefinitionsProp: { type: Boolean },
        additionalTableButtonsProp: { type: Array },
        tableDatePickersProp: { type: Array },
        topSlotComponentsProp: { type: Array },
        componentsToDisplayIfTableHasNoRecords: { type: Function },
        dontShowTableIfItHasNoRecords: { type: Boolean },
        contextProp: { type: Object },
        fetchIntoLocalDataInsteadOfStore: { type: Boolean },
        showInnerLoadingWhenLoadingProp: { type: Boolean },
        unconditionallyShowTheseColumnsInThisOrderProp: { type: Array },
        injectIntoLocalFilterModelProp: { type: Array },
        fetchParamsToMixInProp: { type: Object },
        _fetchParamsToMixInProp: { type: Object },
        doNotApplyFilterModelLocallyProp: { type: Boolean },
        flatTableProp: { type: Boolean },
        borderlessProp: { type: Boolean },
        fetchOnlyVisibleColumnsProp: { type: Boolean },
        rowSelectionModeProp: { type: String, default: 'multiple' },
        initialSelectedIds: { type: Array },
        rowClickHandlerProp: { type: Function },
        disableColumnDraggingProp: { type: Boolean },
        componentsToDisplayAboveTable_prop: { type: Array },
        componentsToDisplayBelowTable_prop: { type: Object },
        hideTopSlotButtonsProp: { type: Boolean },
        showInternalsViewerInDebugMode: { type: Boolean },
        columnsToMixin_prop: { type: Array },
        applyToToBeCreatedRecord: { type: Function },
        eventHandlers: { type: Object },
        executeOnDataLengthChange: { type: Function },
        // when adding props, remember to added combining of component-passed props and props passed from entity definition. see Mark 20210716
        // the above guidance is depricated. TODO: remove it once safe.  AK 20240809
    },
    data() {
        return {
            localData: undefined,
            grandTotalsRow: undefined,
            localSelectedIds: undefined,
            initializationInProcess: false,
            paginationObject: {
                page_size: 10,
                page: 1,
                pages: 1,
                count: -1
            },
            isFullscreen: false,
            loading: false,
            currentFilterEditValueHolder: '',
            uploadListDialogueIsVisible: false,
            uploadListFile: null,
            overwriteOnUniqueConstraintConflict: false,
            downloadListDialogueIsVisible: false,
            downloadMode: 'Human readable',
            columnsToExcludeFromDownload: [],
            currentSelectFilter: null,
            dialogComponentPlaceHolder: null,
            dialogComponentPlaceHolderProps: null,
            filterValueSearchTerm: {},
            localSortingModel: [],
            localSortingModelDialogValueHolder: [],
            localFilterModel: {},
            remoteDistinctLabelsHolder: {},
            columnsLocalCopy: [],
            columnSelectorDialogVisible: false,
            sortingModelDialogVisible: false,
            columnsSelectSearchTerm: '',
            selectedValuesFilterManualIndex: -1,
            forceSelectedValuesFilterSearchBoxToShow: false,
            columnBeingDragged: undefined,
            columnOverWhichAnotherColumnIsBeingDragged: undefined,
            columnOnToWhichAnotherColumnDraggingEnded: undefined,
            idsOfExpandedRows: []
        };
    },
    computed: {
        columnsInColumnList() {
            return this.columnsLocalCopy
                .filter((col) => !col.hideFromColumnList)
                .filter((col) => {
                if (this.columnsSelectSearchTerm === '' || this.columnsSelectSearchTerm === null)
                    return true;
                const label = invokeOrIdentity(col.label || startCase(camelCase(String(col.name))));
                return label.toLowerCase().includes(this.columnsSelectSearchTerm.toLowerCase());
            });
        },
        ctx() { return this; },
        showInternalsViewer() { return isDebugging() && Boolean(this.combineProp('showInternalsViewerInDebugMode')); },
        topSlotProps() {
            return {
                title: this.computedTitle,
                subtitle: this.pageSubtitle,
                hideFullscreenButtonPassedThroughProps: this.hideFullscreenButtonPassedThroughProps,
                hideCreateButtonPassedThroughProps: this.hideCreateButtonPassedThroughProps,
                hideTopSlotButtonsProp: this.hideTopSlotButtonsProp,
                topRightCornerButtonsZoomPassedThroughProps: this.topRightCornerButtonsZoomPassedThroughProps,
                externalFilters: this.externalFilters,
                tableDatePickers: this.tableDatePickers,
                topSlotComponentsProp: this.topSlotComponents,
                ctx: this,
                additionalTableButtons: this.additionalTableButtons,
                localFiltersAreSet: this.localFiltersAreSet,
                hideFiltersAreSetButtonPassedThroughProps: this.hideFiltersAreSetButtonPassedThroughProps,
                localFilterModelShownInTooltip: this.localFilterModelShownInTooltip,
                creatingRecordsIsEnabled: this.creatingRecordsIsEnabled,
                hideRefreshButtonPassedThroughProps: this.hideRefreshButtonPassedThroughProps,
                hideSaveViewButton: this.hideSaveViewButton,
                uploadingListIsEnabled: this.uploadingListIsEnabled,
                hideUploadListButtonPassedThroughProps: this.hideUploadListButtonPassedThroughProps,
                listUploadTemplateDownloadLink: this.listUploadTemplateDownloadLink,
                downloadListDialogueIsVisible: this.downloadListDialogueIsVisible,
                hideDownloadListButtonPassedThroughProps: this.hideDownloadListButtonPassedThroughProps,
                hideTakeSnapshotButtonPassedThroughProps: this.hideTakeSnapshotButtonPassedThroughProps,
                hideColumnSelectorButtonPassedThroughProps: this.hideColumnSelectorButtonPassedThroughProps,
                unconditionallyShowTheseColumnsInThisOrderPassedThroughProps: this.unconditionallyShowTheseColumnsInThisOrderPassedThroughProps,
                hideSortingModelButtonPassedThroughProps: this.hideSortingModelButtonPassedThroughProps,
                localSortingModel: this.localSortingModel,
                createRecordShortcutDisabledPassedThroughProps: this.createRecordShortcutDisabledPassedThroughProps,
                isFullscreen: Boolean(this.isFullscreen)
            };
        },
        headerSlotProps() {
            return {
                columnBeforeWhichDraggedColumnWouldBePlaced: this.columnOverWhichAnotherColumnIsBeingDragged,
                columnBeingDragged: this.columnBeingDragged,
                localFilterModel: this.localFilterModel,
                localSortingModel: this.localSortingModel,
                getHtmlDescriptionOfFilterField: this.getHtmlDescriptionOfFilterField,
                selectedIds: this.selectedIds,
                getColLabel: this.getColLabel,
                getAvailableLocalFilterTypes: this.getAvailableLocalFilterTypes,
                selectedValuesFilterManualIndex: this.selectedValuesFilterManualIndex,
                filterValueSearchTerm: this.filterValueSearchTerm,
                paginationObject: this.paginationObject,
                forceSelectedValuesFilterSearchBoxToShow: this.forceSelectedValuesFilterSearchBoxToShow,
                ctx: this,
                shiftDateFilterAbstract: this.shiftDateFilterAbstract,
                setColumnDisplayTimeZone: this.setColumnDisplayTimeZone,
                getCellPropsObject: this.getCellPropsObject,
                toggleSelectionOfAllVisibleRows: this.toggleSelectionOfAllVisibleRows,
                addToLocalSortingModel: this.addToLocalSortingModel,
                resetColFilter: this.resetColFilter,
                handleFilterTypingInput: this.handleFilterTypingInput,
                handleBlurOnFilterTextInput: this.handleBlurOnFilterTextInput,
                addToLocalFilterModel: this.addToLocalFilterModel,
                handleSelectAllOnFilter: this.handleSelectAllOnFilter,
                allFilterValuesInColumnAreSelected: this.allFilterValuesInColumnAreSelected,
                handleMovementInSelectedValuesFilter: this.handleMovementInSelectedValuesFilter,
                handleEnterPressOnFilterValueSearchInput: this.handleEnterPressOnFilterValueSearchInput,
                updateLocalSetFilter: this.updateLocalSetFilter,
                selectOnlyThisFilterItem: this.selectOnlyThisFilterItem,
                removeSelectedValuesFilterFromColumn: this.removeSelectedValuesFilterFromColumn,
                setColumnVisibility: this.setColumnVisibility,
                resetColumnVisibilityAndOrderToDefaults: this.resetColumnVisibilityAndOrderToDefaults,
                borderLeftIfNeededWhileMovingAnotherColumn: this.borderLeftIfNeededWhileMovingAnotherColumn,
                filterForSearchTerm: this.filterForSearchTerm,
                columnVisibilityAndOrOrderAreDifferentFromDefault: this.columnVisibilityAndOrOrderAreDifferentFromDefault
            };
        },
        bodySlotProps() {
            return {
                columnsFilteredAndEnriched: this.columnsFilteredAndEnriched,
                cellClickHandler: this.cellClickHandler,
                getCellPropsObject: this.getCellPropsObject,
                borderLeftIfNeededWhileMovingAnotherColumn: this.borderLeftIfNeededWhileMovingAnotherColumn,
                localEntityName: this.localEntityName,
                createRecord: this.createRecord,
                getValueFromEnrichedData: this.getValueFromEnrichedData,
                getDisplayValueFromEnrichedData: this.getDisplayValueFromEnrichedData,
                toggleSelection: this.toggleSelection,
                cellIsEditable: this.cellIsEditable,
                handleCellChange: this.handleCellChange,
                selectedIds: this.selectedIds,
                tryToOpenValueSelectorDialog: this.tryToOpenValueSelectorDialog,
                loading: this.loading,
                showInnerLoadingWhenLoadingPassedThroughProps: this.showInnerLoadingWhenLoadingPassedThroughProps,
                ctx: this,
                data: this.data,
                cellContentStyles: this.cellContentStyles,
                updatingRecordsIsEnabled: this.updatingRecordsIsEnabled,
                deleteRow: this.deleteRow,
                editRecord: this.editRecord,
                columnsLocalCopy: this.columnsLocalCopy,
                fillInDefaultValuesOfRecord: this.fillInDefaultValuesOfRecord,
                selectOnlyThisFilterItem: this.selectOnlyThisFilterItem,
                filterOutThisFilterItem: this.filterOutThisFilterItem,
                setDialogComponentPlaceHolder: this.setDialogComponentPlaceHolder,
                openDialog: this.openDialog,
                fetchData: this.fetchData
            };
        },
        bottomSlotProps() {
            return {
                paginationIsNeeded: this.paginationIsNeeded,
                changePaginationPage: this.changePaginationPage,
                handleManualChangeOfRowsPerPage: this.handleManualChangeOfRowsPerPage,
                paginationObject: this.paginationObject,
                rowsPerPageOptionsWithLabels: this.rowsPerPageOptionsWithLabels
            };
        },
        qTableProps() {
            var _a;
            return {
                loading: this.loading,
                dense: true,
                data: this.data,
                wrapCells: true,
                // @ts-ignore
                columns: this.columnsFilteredAndEnriched,
                rowKey: 'id',
                rowsPerPageOptions: this.rowsPerPageOptions,
                hideHeader: this.hideHeaderSlotPassedThroughProps,
                hideBottom: this.hideBottomSlotPassedThroughProps,
                flat: (this.isChildTablePassedThroughProps && this.data.length === 1) || this.flatTablePassedThroughProps,
                bordered: !this.borderlessProp,
                visibleColumns: this.visibleColumns,
                pagination: {
                    page: this.paginationObject.page,
                    rowsNumber: this.paginationObject.count,
                    rowsPerPage: ((_a = this.paginationObject) === null || _a === void 0 ? void 0 : _a.page_size) || 0 + (this.showGrandTotalsRowPassedThroughProps ? 1 : 0) + (this.showTotalsRowPassedThroughProps ? 1 : 0)
                },
                fullscreen: this.isFullscreen
            };
        },
        sortingModelApplyButtonIsDisabled() { return isEqual(this.localSortingModel, this.localSortingModelDialogValueHolder); },
        lastResultsOfUserInducedChangesToTableDisplay: {
            get() {
                const val = getOptionValue(6);
                if (val === 'false')
                    return {};
                if (val && val.length > 0)
                    return JSON.parse(val);
                return {};
            },
            set(val) {
                setOptionValue(6, JSON.stringify(val));
            }
        },
        columnVisibilityAndOrOrderAreDifferentFromDefault() {
            return Boolean(this.tableHasUserInducedChangesToItsDisplay) || Boolean(this.requestedChangesToDataDisplayProp);
        },
        lastResultOfUserInducedChangesToTableDisplay: {
            get() {
                // unusual construct below. but yes, it makes sense
                if (this.requestedChangesToDataDisplayProp)
                    return this.requestedChangesToDataDisplayProp;
                if (!this.tableId)
                    return {};
                return this.lastResultsOfUserInducedChangesToTableDisplay[this.tableId] || {};
            },
            set(val) {
                if (!this.tableId || isEqual(this.lastResultsOfUserInducedChangesToTableDisplay[this.tableId], val))
                    return;
                this.lastResultsOfUserInducedChangesToTableDisplay = Object.assign(Object.assign({}, this.lastResultsOfUserInducedChangesToTableDisplay), { [this.tableId]: val });
            }
        },
        tableHasUserInducedChangesToItsDisplay() {
            const { columnsToHide, columnsToShow, columnsOrder } = this.lastResultOfUserInducedChangesToTableDisplay;
            return arrayHasElements(columnsToHide) || arrayHasElements(columnsToShow) || arrayHasElements(columnsOrder);
        },
        localSortingModelDialogValueHolderSorted() {
            return sortBy(this.localSortingModelDialogValueHolder, ['application_order'], ['asc']);
        },
        standardRowMenuItems() {
            return [
                { name: 'copy_create', nameAliases: ['copy', 'copy_create'], label: 'Copy', icon: 'mdi-content-copy', disabled: !this.creatingRecordsIsEnabled },
                { name: 'add_comment', nameAliases: ['add_comment'], label: 'Add comment', icon: 'mdi-comment-plus-outline' },
                { name: 'del', nameAliases: ['del', 'delete'], label: 'Delete', icon: 'mdi-trash-can-outline', disabled: !this.deletingRecordsIsEnabled },
                { name: 'edit', nameAliases: ['edit', 'update'], label: 'Edit', icon: 'mdi-pencil-box-outline', disabled: !this.updatingRecordsIsEnabled },
                { name: 'view', nameAliases: ['show'], label: 'View', icon: 'mdi-eye' },
                { name: 'create', nameAliases: ['create'], label: 'Create', icon: 'mdi-plus', disabled: !this.creatingRecordsIsEnabled }
            ];
        },
        localFilterModelShownInTooltip() {
            const filters = this.localFilterModel;
            let res = '<div style="margin-top:5px;border-top:1px solid lightgrey">';
            for (const field in filters) {
                res += this.getHtmlDescriptionOfFilterField(field);
            }
            return res;
        },
        doDisguise() { return Boolean(getOptionValue(1) === 'true'); },
        visibleColumns() {
            return this.columnsFilteredAndEnriched
                .filter(not(this.colHideWhenDisplaying))
                .map(col => col.name) || [];
        },
        visibleFields() {
            return this.columnsLocalCopy
                .filter(notUndefined)
                .filter(not(this.colHideWhenDisplaying))
                .map(col => String(col.field));
        },
        isServerSidePagination() { return Boolean(this.paginationObject.page_size); },
        paginationObjectInStore() { return (Store.state[this.localEntityName] || {}).pagination; },
        grandTotalsRowInStore() { return (Store.state[this.localEntityName] || {}).grandTotalsRow; },
        console() { return console; },
        downloadOptions() { return downloadOptions; },
        tableClasses() {
            const res = [];
            if (this.isChildTablePassedThroughProps) {
                res.push('is-child-table');
                if (this.data.length === 1) {
                    res.push('single-row-embedded-child-table');
                }
                else if (this.data.length > 1) {
                    res.push('multi-row-embedded-child-table');
                }
            }
            return res;
        },
        localFiltersAreSet() {
            for (const field in this.localFilterModel)
                if (this.localFilterModel[field])
                    return true;
            return false;
        },
        rowCount() {
            var _a, _b, _c;
            return ((_a = this.paginationObject) === null || _a === void 0 ? void 0 : _a.page_size) || ((_c = (_b = this.data) === null || _b === void 0 ? void 0 : _b.filter(r => !r.isTotalsRow && !r.isGrandTotalsRow)) === null || _c === void 0 ? void 0 : _c.length) || 0;
        },
        computedTitle() {
            if (this.hideTitlePassedThroughProps)
                return undefined;
            const result = this.titlePassedThroughProps || get(this.currentMode, 'pageTitle', null) || getter(this.localEntityName, 'pageTitle');
            return result;
        },
        apiVersion() { return getter(this.localEntityName, 'apiVersion'); },
        repeatLastFetchOnContextOrgIdChange() { return getter(this.localEntityName, 'repeatLastFetchOnContextOrgIdChange'); },
        repeatLastFetchOnContextScopeIntervalChange() { return getter(this.localEntityName, 'repeatLastFetchOnContextScopeIntervalChange'); },
        pageSubtitle() { return this.subTitlePassedThroughProps || getter(this.localEntityName, 'pageSubtitle'); },
        currentMode: {
            get() { return getCurrentMode(); },
            set(val) { setCurrentMode(val); }
        },
        currentMode_reinitialization_requested() {
            return Boolean(this.currentMode.reinitializationRequested);
        },
        localEntityName() { return this.localEntityNameProp || this.currentMode.localEntityName; },
        filters() { return this.filtersPassedThroughProps || this.currentMode.filters; },
        createByAddingRow() { return this.createByAddingRowPassedThroughProps || getter(this.localEntityName, 'createByAddingRow'); },
        onlyShowTheseColumns() {
            if (!this.unconditionallyShowTheseColumnsInThisOrderProp)
                return [];
            const cols = this.unconditionallyShowTheseColumnsInThisOrderProp.map(String);
            return cols;
        },
        columnsToHide() {
            if (this.columnsToHidePropPassedThroughProps && this.columnsToHidePropPassedThroughProps.length > 0)
                return this.columnsToHidePropPassedThroughProps;
            if (this.isChildTablePassedThroughProps)
                return []; // if we don't escape here then on next line we're going to get vuex currentMode columnsToHide, which can be from parent table.  So, we're escaping here.  ColumnsToHide props to childTable should be passed as props
            return this.currentMode.columnsToHide || [];
        },
        permanentSortingModel() {
            if (this.draggableSortable)
                return ({ fields: ['application_order'], orders: ['asc'] });
            return this.permanentSortingModelPassedThroughProps;
        },
        permanentSortingModelV1() {
            var _a, _b, _c, _d;
            const res = [];
            const application_order = 1;
            for (const [index, field] of ((_b = (_a = this.permanentSortingModel) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.entries()) || []) {
                res.push({ field, application_order, direction: ((_d = (_c = this.permanentSortingModel) === null || _c === void 0 ? void 0 : _c.orders) === null || _d === void 0 ? void 0 : _d[index]) || 'asc' });
            }
            return res;
        },
        startingSortingModel() {
            return this.startingSortingModelPassedThroughProps;
        },
        startingFilterModelV1() {
            return this.startingFilterModelPassedThroughProps || [];
        },
        startingFilterModelV0() {
            return transformFilterModelFromV1ToV0IfNotYet(this.startingFilterModelV1);
        },
        sourceData() {
            return this.localData || this.dataPassedThroughProps || getRecords(this.localEntityName, { preferFullTable: false }) || [];
        },
        enrichedSourceData() {
            // console.info('enrichedSourceData getter')
            if (!this.sourceData || !Array.isArray(this.sourceData) || this.sourceData.length === 0)
                return [];
            // console.info('enrichedSourceData getter 2')
            const res = cloneDeep(this.sourceData);
            // console.info('enrichedSourceData getter 3')
            // console.info(`start row enrichment. Row count ${res.length}. LocalEntityName ${this.localEntityName}`)
            // console.log('columnsFilteredAndEnriched', this.columnsFilteredAndEnriched)
            for (const col of this.columnsFilteredAndEnriched) {
                // console.info(`start column enrichment. Column ${col.name}`)
                // console.log('col', col)
                if (typeof res.forEach !== 'function')
                    debugger;
                res.forEach(row => {
                    // console.info('start row enrichment for column', col.name)
                    if (row.isGrandTotalsRow || row.isTotalRow)
                        return;
                    row[col.name + '_value'] = getValue(col, row);
                    row[col.name + '_display_value'] = getDisplayValue(col, row);
                });
            }
            // console.info('end row enrichment')
            return res;
        },
        data: {
            get() {
                var _a;
                // console.info('data getter')
                const { enrichedSourceData } = this;
                // console.log('enrichedSourceData', enrichedSourceData)
                // console.table(enrichedSourceData)
                const src = cloneDeep(enrichedSourceData); // as S[]
                // console.info('after src = cloneDeep(enrichedSourceData)')
                if (!src || src.length === 0)
                    return [];
                let res = cloneDeep(src);
                // console.info('data getter end')
                if (!this.doNotApplyFilterModelLocallyPassedThroughProps) {
                    // console.info('data getter filtering')
                    // applying filters that were passed into currentMode or via props
                    const filters = omit(this.filters, Object.keys(this.localFilterModel || {})); // we excluded filters that are present in localFilterModel, because they will be checked after this
                    if (filters) {
                        res = [];
                        const keys = Object.keys(filters);
                        src.forEach((s) => {
                            let include = true;
                            keys.forEach(key => {
                                if (filters[key] !== null && s[key] !== filters[key])
                                    include = false;
                            });
                            if (include)
                                res.push(s);
                        });
                    }
                    // console.info('data getter filtering end')
                    /* not using this anymore but may in the future:
                    // enriching with _value and _display_value
                    for (const col of this.columnsFilteredAndEnriched) {
                      for (const row of res) {
                        Vue.set(row, col.name + '_value', getValueFromEnrichedData(col, row))
                        Vue.set(row, col.name + '_display_value', getDisplayValueFromEnrichedData(col, row))
                      }
                    }
                    */
                    // applying local filters
                    // const localFilters = _.pick(this.localFilterModel, this.columnsFilteredAndEnriched.map((col: any) => col.name)) // mark 20200208 why we need to pick from localFilterModel: because it is possible that 2 tables draw on the same vuex table module, and it is possible that one of the tables has fewer to display columns than the other; so, if the other table had filter set on a column that is not visible in the current table, then situation may occur that filtering happens on a column that is not visible; that would be confusing to a user and would be difficult to debug
                    const localFilters = Object.assign(Object.assign({}, this.localFilterModel), transformFilterModelFromV1ToV0(this.permanentInvisibleToUserFilterModelProps || []));
                    // console.info('data getter local filtering')
                    for (const colName in localFilters) {
                        const currentCol = this.columnsLocalCopy.find((r) => r.name === colName);
                        if (currentCol === undefined)
                            continue;
                        const firstRow = res[0];
                        if (!firstRow)
                            continue;
                        if (!((_a = Object.keys(firstRow)) === null || _a === void 0 ? void 0 : _a.includes(String(currentCol.field))))
                            continue;
                        for (const predicate in localFilters[colName]) {
                            const filterPredicate = predicate;
                            if ((this.startingFilterModelV1 || []).some((r) => r.doNotApplyLocally && r.field === colName && r.predicate === filterPredicate)) {
                                continue;
                            }
                            const fValue = localFilters[colName][filterPredicate];
                            if (fValue !== undefined && String(fValue).length > 0) {
                                let needle;
                                if (typeof fValue === 'string') {
                                    needle = fValue.toLowerCase();
                                }
                                else if (Array.isArray(fValue)) {
                                    // do nothing, because no transformation needed
                                }
                                else {
                                    needle = String(fValue);
                                }
                                const getDisplayValueLc = (col, row) => {
                                    let displayValue = getDisplayValueFromEnrichedData(col, row);
                                    if (displayValue === undefined || displayValue === '<empty>')
                                        displayValue = '';
                                    return String(displayValue).toLowerCase();
                                };
                                const numberValue = (row) => Number(getValueFromEnrichedData(currentCol, row));
                                switch (filterPredicate) {
                                    case 'contains':
                                        res = res.filter((row) => getDisplayValueLc(currentCol, row).includes(String(needle)));
                                        break;
                                    case 'overlapsWith':
                                        res = res.filter((row) => arraysDoOverlap(getValue(currentCol, row) || [], needle));
                                        break;
                                    case 'doesNotContain':
                                        res = res.filter((row) => !getDisplayValueLc(currentCol, row).includes(needle));
                                        break;
                                    case 'equals':
                                        res = res.filter((row) => {
                                            if (currentCol.isDate)
                                                return datesAreEqual(String(row[colName]), needle);
                                            if (currentCol.isNumeric || currentCol.isInteger || currentCol.name === 'id')
                                                return numberValue(row) === Number(needle);
                                            const defaultResult = getDisplayValueLc(currentCol, row) === String(needle);
                                            return defaultResult;
                                        });
                                        break;
                                    case 'doesNotEqual':
                                        res = res.filter((row) => {
                                            if (currentCol.isNumeric)
                                                return numberValue(row) !== Number(needle);
                                            return getDisplayValueLc(currentCol, row) !== needle;
                                        });
                                        break;
                                    case 'beginsWith':
                                        res = res.filter((row) => getDisplayValueLc(currentCol, row).indexOf(needle) === 0);
                                        break;
                                    case 'endsWith':
                                        res = res.filter((row) => getDisplayValueLc(currentCol, row).slice(-needle.length) === needle);
                                        break;
                                    case 'containedIn':
                                        res = res.filter((row) => {
                                            if (currentCol.isArray) {
                                                return row[currentCol.field] && row[currentCol.field].some((val) => localFilters[colName].containedIn.includes(val));
                                            }
                                            else {
                                                const containedInSet = localFilters[colName].containedIn;
                                                const val = getValueFromEnrichedData(currentCol, row);
                                                const b = containedInSet.some((s) => String(s) === String(val));
                                                return b;
                                            }
                                        });
                                        break;
                                    case 'before':
                                        res = res.filter((row) => dateAIsBeforeB(String(row[colName]), needle));
                                        break;
                                    case 'after':
                                        res = res.filter((row) => dateAIsBeforeB(needle, String(row[colName])));
                                        break;
                                    case 'greaterThan':
                                        res = res.filter((row) => {
                                            if (currentCol.isDate)
                                                return dateAIsAfterB(String(row[colName]), needle);
                                            return numberValue(row) > Number(needle);
                                        });
                                        break;
                                    case 'greaterThanOrEqualTo':
                                        res = res.filter((row) => {
                                            if (currentCol.isDate)
                                                return dateAIsGreaterThanOrEqualToB(String(row[colName]), needle);
                                            return numberValue(row) >= Number(needle);
                                        });
                                        break;
                                    case 'lessThan':
                                        res = res.filter((row) => {
                                            if (currentCol.isDate)
                                                return dateAIsBeforeB(String(row[colName]), needle);
                                            return numberValue(row) < Number(needle);
                                        });
                                        break;
                                    case 'lessThanOrEqualTo':
                                        res = res.filter((row) => {
                                            if (currentCol.isDate)
                                                return dateAIsGreaterThanOrEqualToB(needle, String(row[colName]));
                                            return numberValue(row) <= Number(needle);
                                        });
                                        break;
                                }
                            }
                        }
                    }
                }
                // applying sorting
                const psm = this.permanentSortingModel;
                const lsm = this.localSortingModel;
                if (psm) {
                    res = orderBy(res, psm.fields, psm.orders);
                }
                else if (lsm && Array.isArray(lsm) && lsm.length > 0) {
                    const applicationOrders = lsm.map(sm => sm.application_order).sort();
                    const getFieldSuffix = (field) => {
                        const col = this.columnsSource.find(col => col.field === field);
                        if ((col === null || col === void 0 ? void 0 : col.isTime) || (col === null || col === void 0 ? void 0 : col.isDate) || (col === null || col === void 0 ? void 0 : col.isDateTime) || (col === null || col === void 0 ? void 0 : col.isNumeric) || (col === null || col === void 0 ? void 0 : col.isPercent) || (col === null || col === void 0 ? void 0 : col.isInteger) || (col === null || col === void 0 ? void 0 : col.isCurrency)) {
                            return '_value';
                        }
                        else {
                            return '_display_value';
                        }
                    };
                    const fields = applicationOrders.map(ao => {
                        var _a;
                        const field = (_a = lsm.find(sm => sm.application_order === ao)) === null || _a === void 0 ? void 0 : _a.field;
                        if (field === undefined)
                            return undefined;
                        const fieldSuffix = getFieldSuffix(String(field));
                        return field + fieldSuffix;
                    });
                    const directions = applicationOrders.map(ao => { var _a, _b; return ((_b = (_a = lsm.find(sm => sm.application_order === ao)) === null || _a === void 0 ? void 0 : _a.direction) === null || _b === void 0 ? void 0 : _b.split(' ')[0]) || 'asc'; });
                    // @ts-ignore
                    res = orderBy(res, fields, directions);
                }
                // generating totals row if needed
                if (this.showTotalsRowPassedThroughProps && res.length > 1 /* i.e., not showing totals row if there is not more than 1 row */) {
                    let totalsRow = { isTotalsRow: true };
                    const updateTotalsRow = (col, value) => {
                        totalsRow = Object.assign(Object.assign({}, totalsRow), { [col.name]: getDisplayValue(col, { [col.field]: value }) });
                        totalsRow = Object.assign(Object.assign({}, totalsRow), { [col.name + '_value']: getValue(col, { [col.field]: value }) });
                    };
                    this.columnsLocalCopy.forEach((col) => {
                        if (col.totalsRowText) {
                            updateTotalsRow(col, col.totalsRowText);
                        }
                        const columnOfValues = res.map((r) => r[col.name]);
                        const aggValueGetterMap = {
                            sum: (r) => columnOfValues.reduce((a, b) => Number(a) + Number(b), 0),
                            max: (r) => columnOfValues.reduce((a, b) => Math.max(Number(a), Number(b)), 0),
                            min: (r) => columnOfValues.reduce((a, b) => Math.min(Number(a), Number(b)), 0),
                            avg: (r) => columnOfValues.reduce((a, b) => Number(a) + Number(b), 0) / columnOfValues.length,
                            count_distinct: (r) => [...new Set(columnOfValues)].length,
                            count: (r) => columnOfValues.length,
                            array_merge: (r) => columnOfValues.reduce((a, b) => [...a, ...b], []),
                            array_agg: (r) => columnOfValues
                        };
                        if (col.totalsRowAgg && typeof col.totalsRowAgg !== 'function' && Object.keys(aggValueGetterMap).includes(col.totalsRowAgg)) {
                            const value = aggValueGetterMap[col.totalsRowAgg](res);
                            updateTotalsRow(col, value);
                        }
                    });
                    // making second pass through columns to process totals row calculations that depend on other column calculations
                    const _totalsRow = Object.assign({}, totalsRow);
                    for (const key in totalsRow) {
                        if (key.endsWith('_value')) {
                            // replace last 6 chars with '' to remove '_value' from the end
                            _totalsRow[key.slice(0, -6)] = totalsRow[key];
                        }
                    }
                    this.columnsLocalCopy.forEach((col) => {
                        if (typeof col.totalsRowAgg === 'function')
                            updateTotalsRow(col, col.totalsRowAgg(_totalsRow));
                    });
                    // adding the totals row to the end of the data
                    res.push(totalsRow);
                }
                // generating grand totals row if needed
                if (this.showGrandTotalsRowPassedThroughProps) {
                    const grandTotalsRow = Object.assign(Object.assign({}, this.grandTotalsRow), { isGrandTotalsRow: true });
                    if (!grandTotalsRow)
                        throw new Error('grandTotalsRow is not defined');
                    const grandTotalsRow_accumulator = Object.assign(Object.assign({}, grandTotalsRow), this.columnsLocalCopy.map((col) => {
                        const _value = getValue(col, grandTotalsRow);
                        const _display_value = col.grandTotalsRowText || getDisplayValue(col, grandTotalsRow);
                        return [{ [col.name]: _display_value }, { [col.name + '_display_value']: _display_value }, { [col.name + '_value']: _value }];
                    }).flat().reduce((a, b) => (Object.assign(Object.assign({}, a), b)), { isGrandTotalsRow: true }));
                    // second pass to process grand totals row calculations that depend on other column calculations
                    const grandTotalsRow_values = Object.keys(grandTotalsRow_accumulator)
                        .filter(key => key.endsWith('_value'))
                        .map(key => ({ [key.slice(0, -6)]: grandTotalsRow_accumulator[key] }))
                        .reduce((a, b) => (Object.assign(Object.assign({}, a), b)), { isGrandTotalsRow: true });
                    const grandTotalsRow_accumulator2 = this.columnsLocalCopy
                        .filter(col => typeof col.grandTotalCalculation === 'function')
                        .map(col => {
                        if (!grandTotalsRow_values)
                            throw new Error('grandTotalsRow_values is not defined');
                        const _value = col.grandTotalCalculation ? col.grandTotalCalculation(grandTotalsRow_values) : undefined;
                        const _display_value = getDisplayValue(col, { [col.field]: _value });
                        return [{ [col.name]: _display_value }, { [col.name + '_display_value']: _display_value }, { [col.name + '_value']: _value }];
                    })
                        .flat()
                        .reduce((a, b) => (Object.assign(Object.assign({}, a), b)), {});
                    const newGrandTotalsRow = Object.assign(Object.assign({}, grandTotalsRow_accumulator), grandTotalsRow_accumulator2);
                    res.push(newGrandTotalsRow);
                }
                // returning the result of computed 'data' 'get'
                return res;
            },
            set(newVal) {
                if (this.dataPassedThroughProps) {
                    this.emitEvent('set-data', newVal);
                }
                else {
                    setRecords(this.localEntityName, newVal);
                }
            }
        },
        draggableSortable() {
            return this.draggableSortablePassedThroughProps && !this.suppressDraggableSortablePassedThroughProps && this.sourceData.length > 1;
        },
        columnsFilteredAndEnriched() {
            let res = this.columnsLocalCopy;
            if (!res || !Array.isArray(res) || res.length === 0)
                return [];
            // apply lastResultsOfUserInducedChangesToTableStructures
            const lastForTable = this.lastResultOfUserInducedChangesToTableDisplay;
            const columnsToHide = get(lastForTable, 'columnsToHide') || [];
            const columnsToShow = get(lastForTable, 'columnsToShow') || [];
            if (typeof res.forEach !== 'function')
                debugger;
            if (columnsToHide.length > 0)
                res.forEach(col => { if (columnsToHide.includes(col.name))
                    col.hideWhenDisplaying = true; });
            if (columnsToShow.length > 0)
                res.forEach(col => { if (columnsToShow.includes(col.name))
                    col.hideWhenDisplaying = false; });
            // conditionally removing columns from displayed columns, based on various rules
            if (this.unconditionallyShowTheseColumnsInThisOrderPassedThroughProps) {
                let cols = [];
                const columnsToShow = this.unconditionallyShowTheseColumnsInThisOrderPassedThroughProps;
                // const columnNames = res.map(col => col.name)
                // console.log('columnsToShow', columnsToShow)
                // console.log('columnNames', columnNames)
                for (const colName of columnsToShow) {
                    const iCol = res.find(col => col.name === colName);
                    if (iCol) {
                        cols = [...cols, Object.assign(Object.assign({}, iCol), { hideWhenDisplaying: false })];
                    }
                }
                res = cols;
            }
            else {
                res = res.filter(col => {
                    if (this.colHideWhenDisplaying(col))
                        return false;
                    if (this.columnsToHide.includes(String(col.name)))
                        return false;
                    if (this.onlyShowTheseColumns.length > 0 && this.onlyShowTheseColumns.includes(String(col.name)))
                        return false;
                    if (col.isHidden !== undefined) {
                        if (typeof col.isHidden === 'boolean' && col.isHidden)
                            return false;
                        if (typeof col.isHidden === 'function' && col.isHidden(this.sourceData))
                            return false;
                    }
                    if (col.hideForTenandIds && col.hideForTenandIds.includes(getSessionContext().tenant_id))
                        return false;
                    if (this.hideRowDeleteButtonPassedThroughProps && col.name === 'del')
                        return false;
                    if (this.hideRowViewButtonPassedThroughProps && col.name === 'view')
                        return false;
                    if (this.hideRowSelectorButtonPassedThroughProps && col.name === 'selector')
                        return false;
                    return true;
                });
            }
            // conditionally injecting columns
            // 'handle' column should be added first, as it seems that it stops working if it is added later (probably after child table column)
            if (this.draggableSortable) {
                res = [{ displayOrder: -2, name: 'handle', style: 'width: 20px', hideWhenDisplaying: false, field: '' }, ...res];
            }
            if (this.forceShowingRowSelectorRegardlessOfColumnsDefinitionsPassedThroughProps && !res.some(r => r.name === 'selector')) {
                res = [{ name: 'selector', field: '', label: '', style: 'width: 25px', displayOrder: -1 }, ...res];
            }
            // sorting columns in display order
            res = orderBy(res, ['displayOrder'], ['asc']);
            // note that this func mutates in place
            const addFilterIfDoesNotExist = (col, filterName) => {
                if (!col.uiFilterTypes) {
                    col.uiFilterTypes = [filterName];
                }
                else if (!col.uiFilterTypes.includes(filterName)) {
                    col.uiFilterTypes.push(filterName);
                }
            };
            // apply various transformations to each column
            if (typeof res.forEach !== 'function')
                debugger;
            res.forEach(col => {
                // if (col.references || col.complexlyReferences || col.possibleValues) addFilterIfDoesNotExist(col, 'selectedValuesFilter')
                if (col.isNumeric)
                    addFilterIfDoesNotExist(col, 'numberFilters');
                if (col.isDate)
                    addFilterIfDoesNotExist(col, 'dateFilters');
                if (col.isCheckbox)
                    addFilterIfDoesNotExist(col, 'booleanFilters');
                if (!col.isTextarea)
                    addFilterIfDoesNotExist(col, 'selectedValuesFilter');
                if (!col.isNumeric)
                    addFilterIfDoesNotExist(col, 'textFilters');
                // add menu item's definitions where needed
                if (col.menuItemShortcuts) {
                    col.menuItemShortcuts.forEach(shortCut => {
                        this.standardRowMenuItems.forEach(menuItem => {
                            if (menuItem.name === shortCut || (menuItem.nameAliases || []).includes(shortCut)) {
                                if (col.rowMenuItems === undefined)
                                    col.rowMenuItems = [];
                                if (!col.rowMenuItems.some(mi => mi.name === menuItem.name)) {
                                    col.rowMenuItems.push(menuItem);
                                }
                            }
                        });
                    });
                }
            });
            return res;
        },
        selectedIds: {
            get() {
                var _a;
                return (this.localEntityName ? (_a = Store.state[this.localEntityName]) === null || _a === void 0 ? void 0 : _a.selectedIds : this.localSelectedIds) || [];
            },
            set(newVal) {
                if (this.localEntityName) {
                    Store.commit(this.localEntityName + '/SET_SELECTED_IDS', newVal);
                }
                else {
                    this.localSelectedIds = newVal;
                }
                this.emitEvent('selected-ids', newVal);
                this.emitEvent('selected-records', this.selectedRecords);
            }
        },
        selectedRecords() { return this.enrichedSourceData.filter(r => this.selectedIds.includes(r.id)); },
        tableId() {
            const id = this.combineProp('tableIdProp');
            if (!id)
                return undefined;
            if (typeof id !== 'string')
                return undefined;
            if (id.length === 0)
                return undefined;
            return id;
        },
        // #region combineProps
        // start mixining in and combining props passed from entity definition and props passed by component.  Mark 20210716
        fetchOnlyVisibleColumns() { return this.combineProp('fetchOnlyVisibleColumnsProp'); },
        genericTablePropsPassedFromEntityDefinition() { return getter(this.localEntityName, 'genericTableDefaultProps') || {}; },
        columnsSource() {
            const columns = [
                ...(this.columnsToMixin_prop || []),
                ...(this.columnsProp ? this.columnsProp : getColumns(this.localEntityName)),
            ];
            return columns.map(fromColumnToStrictColumn);
        },
        // TODO: refactor to remove mixing in of props from CurrentMode (propPassedThroughDepricatedWayOfCurrentMode). Then refactor to simplify, while continueing accomodating mixing in of props passed through component props and passed through entity definisions. AK 20240809
        dataPassedThroughProps() { return this.combineProp('dataProp'); },
        initialDataPropThroughProps() { return this.combineProp('initialDataProp'); },
        filtersPassedThroughProps() { return this.combineProp('filtersProp'); },
        titlePassedThroughProps() { return this.combineProp('title'); },
        subTitlePassedThroughProps() { return this.combineProp('subTitle'); },
        hideRowDeleteButtonPassedThroughProps() { return Boolean(this.combineProp('hideRowDeleteButton')); },
        hideRowViewButtonPassedThroughProps() { return Boolean(this.combineProp('hideRowViewButton')); },
        hideRowSelectorButtonPassedThroughProps() { return Boolean(this.combineProp('hideRowSelectorButton')); },
        hideCreateButtonPassedThroughProps() { return Boolean(this.combineProp('hideCreateButton')); },
        hideFiltersAreSetButtonPassedThroughProps() { return Boolean(this.combineProp('hideFiltersAreSetButton')); },
        createRecordShortcutDisabledPassedThroughProps() { return Boolean(this.combineProp('createRecordShortcutDisabled')); },
        hideUploadListButtonPassedThroughProps() { return Boolean(this.combineProp('hideUploadListButton')); },
        hideRefreshButtonPassedThroughProps() { return Boolean(this.combineProp('hideRefreshButton')); },
        hideDownloadListButtonPassedThroughProps() { return Boolean(this.combineProp('hideDownloadListButton')); },
        hideTakeSnapshotButtonPassedThroughProps() { return Boolean(this.combineProp('hideTakeSnapshotButton')); },
        hideFullscreenButtonPassedThroughProps() { return Boolean(this.combineProp('hideFullscreenButton')); },
        hideColumnSelectorButtonPassedThroughProps() { return Boolean(this.combineProp('hideColumnSelectorButton')); },
        unconditionallyShowTheseColumnsInThisOrderPassedThroughProps() { return this.combineProp('unconditionallyShowTheseColumnsInThisOrderProp'); },
        hideSortingModelButtonPassedThroughProps() { return Boolean(this.combineProp('hideSortingModelButton')); },
        initialRowsPerPagePropPassedThroughProps() { return this.combineProp('initialRowsPerPageProp') || 10; },
        initialRowsPerPage_lastUserAction() {
            var _a;
            const last = (_a = this.lastResultOfUserInducedChangesToTableDisplay) === null || _a === void 0 ? void 0 : _a.rowsPerPage;
            if (!last || last > 999)
                return undefined;
            return last;
        },
        initialRowsPerPage_effective() {
            return this.initialRowsPerPage_lastUserAction || this.initialRowsPerPagePropPassedThroughProps;
        },
        showGrandTotalsRowPassedThroughProps() { return this.combineProp('showGrandTotalsRowProp'); },
        showTotalsRowPassedThroughProps() { return this.combineProp('showTotalsRowProp'); },
        disableColumnDraggingPassedThroughProps() { return this.combineProp('disableColumnDraggingProp'); },
        updatingRecordsIsEnabledPassedThroughProps() { return this.combineProp('updatingRecordsIsEnabledProp'); },
        updatingRecordsIsDisabledPassedThroughProps() { return this.combineProp('updatingRecordsIsDisabledProp'); },
        creatingRecordsIsEnabledPassedThroughProps() { return this.combineProp('creatingRecordsIsEnabledProp'); },
        creatingRecordsIsDisabledPassedThroughProps() { return this.combineProp('creatingRecordsIsDisabledProp'); },
        hideTitlePassedThroughProps() { return this.combineProp('hideTitleProp'); },
        hideHeaderSlotPassedThroughProps() { return this.combineProp('hideHeaderSlotProp'); },
        hideTopSlotPassedThroughProps() { return this.combineProp('hideTopSlotProp'); },
        hideBottomSlotPassedThroughProps() { return this.combineProp('hideBottomSlotProp'); },
        draggableSortablePassedThroughProps() { return this.combineProp('draggableSortableProp'); },
        suppressDraggableSortablePassedThroughProps() { return this.combineProp('suppressDraggableSortableProp'); },
        showAddButtonWhenDataIsEmptyPassedThroughProps() { return this.combineProp('showAddButtonWhenDataIsEmptyProp'); },
        createByAddingRowPassedThroughProps() { return this.combineProp('createByAddingRowProp'); },
        isChildTablePassedThroughProps() { return this.combineProp('isChildTableProp'); },
        columnsToHidePropPassedThroughProps() { return this.combineProp('columnsToHideProp'); },
        startingSortingModelPassedThroughProps() { return this.combineProp('startingSortingModelProp'); },
        startingFilterModelPassedThroughProps() { return this.combineProp('startingFilterModelProp'); },
        permanentInvisibleToUserFilterModelProps() { return this.combineProp('permanentInvisibleToUserFilterModelProp'); },
        actionArgumentsPassedThroughProps() { return this.combineProp('actionArgumentsProp'); },
        permanentSortingModelPassedThroughProps() { return this.combineProp('permanentSortingModelProp'); },
        controlledActions() { return this.combineProp('controlledActionsProp') || getter(this.localEntityName, 'controlledActions'); },
        initiationOfRecordCreationHandler() { return this.combineProp('initiationOfRecordCreationHandlerProp') || getter(this.localEntityName, 'initiationOfRecordCreationHandler'); },
        rowIsLockedFunctionPassedThroughProps() { return this.combineProp('rowIsLockedFunctionProp'); },
        topRightCornerButtonsZoomPassedThroughProps() { return this.combineProp('topRightCornerButtonsZoomProp'); },
        doNotFetchDataPassedThroughProps() { return this.combineProp('doNotFetchDataProp'); },
        rowSelectionModePassedThroughProps() { return this.combineProp('rowSelectionModeProp'); },
        initialSelectedIdsPassedThroughProps() { return this.combineProp('initialSelectedIds'); },
        forceShowingRowSelectorRegardlessOfColumnsDefinitionsPassedThroughProps() { return this.combineProp('forceShowingRowSelectorRegardlessOfColumnsDefinitionsProp'); },
        additionalTableButtons() { return (this.combineProp('additionalTableButtonsProp') || getter(this.localEntityName, 'additionalTableButtons')) || []; },
        tableDatePickers() { return (this.combineProp('tableDatePickersProp') || getter(this.localEntityName, 'tableDatePickers')); },
        topSlotComponents() { return this.combineProp('topSlotComponentsProp'); },
        dontShowTableIfItHasNoRecordsPassedThroughProps() { return this.combineProp('dontShowTableIfItHasNoRecords'); },
        fetchIntoLocalDataInsteadOfStorePassedThroughProps() { return this.combineProp('fetchIntoLocalDataInsteadOfStore'); },
        showInnerLoadingWhenLoadingPassedThroughProps() { return this.combineProp('showInnerLoadingWhenLoadingProp'); },
        fetchParamsToMixInPassedThroughProps() { return deepmerge(this.combineProp('fetchParamsToMixInProp') || {}, this.combineProp('_fetchParamsToMixInProp') || {}); },
        doNotApplyFilterModelLocallyPassedThroughProps() { return this.combineProp('doNotApplyFilterModelLocallyProp'); },
        flatTablePassedThroughProps() { return this.combineProp('flatTableProp'); },
        // #endregion combineProps
        externalFilters() { return getter(this.localEntityName, 'externalFilters'); },
        uniqueConstraints() { return getter(this.localEntityName, 'uniqueConstraints') || []; },
        rowValidationRules() { return getter(this.localEntityName, 'rowValidationRules') || []; },
        listUploadTemplateDownloadLink() { return getter(this.localEntityName, 'listUploadTemplateDownloadLink'); },
        downloadableColumns() {
            if (!this.columnsSource)
                return [];
            return this.columnsSource.filter((col) => !col.excludeFromDownloadableColumns && !['del', 'link'].includes(String(col.name)) && !this.columnsToHide.includes(String(col.name)));
        },
        columnsToDownload() { return this.downloadableColumns.filter((r) => !(this.columnsToExcludeFromDownload.includes(r.label || r.downloadLabel))); },
        current() { return (Store.state[this.localEntityName] || {}).current; },
        creatingRecordsIsEnabled() {
            var _a;
            if (!this.actingUserHasControlledAction((_a = this.controlledActions) === null || _a === void 0 ? void 0 : _a.create))
                return false;
            if (this.currentMode.creatingRecordsIsDisabled || this.creatingRecordsIsDisabledPassedThroughProps)
                return false;
            if (this.creatingRecordsIsEnabledPassedThroughProps === false)
                return false;
            return true;
        },
        updatingRecordsIsEnabled() {
            var _a, _b;
            if (((_a = this.controlledActions) === null || _a === void 0 ? void 0 : _a.update) && !this.actingUserHasControlledAction((_b = this.controlledActions) === null || _b === void 0 ? void 0 : _b.update))
                return false;
            if (this.updatingRecordsIsDisabledPassedThroughProps)
                return false;
            if (this.updatingRecordsIsEnabledPassedThroughProps === false)
                return false;
            return true;
        },
        deletingRecordsIsEnabled() {
            var _a, _b;
            if (((_a = this.controlledActions) === null || _a === void 0 ? void 0 : _a.delete) && !this.actingUserHasControlledAction((_b = this.controlledActions) === null || _b === void 0 ? void 0 : _b.delete))
                return false;
            return true;
        },
        uploadingListIsEnabled() { var _a; return this.actingUserHasControlledAction((_a = this.controlledActions) === null || _a === void 0 ? void 0 : _a.uploadList); },
        dataLength() {
            const result = Number((this.data || []).length || 0);
            // console.log('dataLength getter result', result)
            return result;
        },
        paginationIsNeeded() {
            const { dataLength } = this;
            const { page = -1, page_size = -1, pages = -1 } = this.paginationObject;
            const { initialRowsPerPagePropPassedThroughProps, isServerSidePagination } = this;
            if (initialRowsPerPagePropPassedThroughProps && initialRowsPerPagePropPassedThroughProps < dataLength)
                return true;
            return (isServerSidePagination && pages > 1) ||
                dataLength > page_size ||
                page_size === 0 ||
                page > 1;
        },
        rowsPerPageOptions() { return [10, 15, 20, 25, 30, 50, 100, 200, 300]; },
        rowsPerPageOptionsWithLabels() { return this.rowsPerPageOptions.map((r) => ({ value: r, label: (r === 0 ? 'All' : `${r}`) })); },
        sessionContextOrgId() { return getSessionContext().org_id; },
        sessionContextScopeInterval() {
            return {
                from: getSessionContext().scope_date_from || getToday(),
                to: getSessionContext().scope_date_to || getToday()
            };
        },
        dataObtainedFrom__dataGetter_prop() {
            return invokeOrUndefined(this.dataGetter_prop, this);
        }
    },
    watch: {
        dataObtainedFrom__dataGetter_prop: {
            immediate: true,
            handler(newVal) {
                if (!newVal)
                    return;
                if (this.dataGetterResultHandler_prop) {
                    this.dataGetterResultHandler_prop(this, newVal);
                }
                else {
                    this.localData = newVal;
                }
            }
        },
        sortingModelDialogVisible(newVal) {
            if (newVal)
                this.localSortingModelDialogValueHolder = cloneDeep(this.localSortingModel);
        },
        lastResultOfUserInducedChangesToTableDisplay: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
                if (!isEqual(omit(newVal, 'columnsOrder'), omit(oldVal, 'columnsOrder'))) {
                    this.initializeColumns();
                }
                else if (!isEqual(newVal === null || newVal === void 0 ? void 0 : newVal.columnsOrder, oldVal === null || oldVal === void 0 ? void 0 : oldVal.columnsOrder)) {
                    this.columnsLocalCopy = this.columnsLocalCopy.map((col) => {
                        const newCol = Object.assign({}, col);
                        // @ts-ignore
                        newCol.displayOrder = ((newVal === null || newVal === void 0 ? void 0 : newVal.columnsOrder) || []).indexOf(col.name);
                        return newCol;
                    });
                }
            }
        },
        columnsLocalCopy: {
            immediate: false,
            deep: true,
            handler(newVal, oldVal) {
                // debugger
            }
        },
        'paginationObject.page_size': {
            immediate: false,
            handler(newVal) {
                if (newVal !== undefined) {
                    this.lastResultOfUserInducedChangesToTableDisplay = Object.assign(Object.assign({}, this.lastResultOfUserInducedChangesToTableDisplay), { rowsPerPage: newVal });
                }
            }
        },
        initialSelectedIds: {
            immediate: true,
            handler(newVal) {
                if (newVal && Array.isArray(newVal))
                    this.selectedIds = newVal;
            }
        },
        initialDataPropThroughProps: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    if (typeof newVal === 'function') {
                        this.localData = newVal();
                    }
                    else {
                        this.localData = newVal;
                    }
                }
            }
        },
        sessionContextOrgId: {
            immediate: false,
            handler() {
                if (this.repeatLastFetchOnContextOrgIdChange)
                    repeatLastFetch(this.localEntityName);
            }
        },
        sessionContextScopeInterval: {
            immediate: false,
            deep: true,
            handler() {
                if (this.repeatLastFetchOnContextScopeIntervalChange)
                    repeatLastFetch(this.localEntityName);
            }
        },
        dataLength: {
            immediate: true,
            handler(newVal, oldVal) {
                invokeOrVoid(this.executeOnDataLengthChange, { newVal, oldVal, ctx: this });
                // console.log('dataLength watcher newVal', newVal)
                // console.log('paginationObject', this.paginationObject)
                if ((newVal === undefined || newVal === 0) && this.paginationObject.page > 1) {
                    // i.e., if data to display is empty, and page in pagination is > 1, we try re-fetching data but with page number 1
                    // such situation may arrise when we apply filter to data, and we are on >1 page. That page becomes empty
                    // console.log('About to execute fetchData with page 1')
                    this.fetchData(this.paginationObject.page_size, 1);
                    // console.log('Exited fetchData with page 1')
                }
            }
        },
        visibleFields(newVal, oldVal) {
            // If we make a new column visible while in fetchOnlyVisibleColumns mode, there is no data for it.  Therefore we need to repeat fetching data, now with the new field included
            if (this.fetchOnlyVisibleColumns) {
                if (newVal.some((field) => !oldVal.includes(field)) || oldVal.some((field) => !newVal.includes(field))) {
                    this.fetchData();
                }
            }
        },
        injectIntoLocalFilterModelProp: {
            immediate: false,
            handler(newVal) {
                if (!newVal || !Array.isArray(newVal))
                    return;
                for (const fc of newVal) {
                    this.addToLocalFilterModel({ name: fc.field, field: fc.field }, fc.predicate, fc.value);
                }
            }
        },
        loading(newVal) { this.emitEvent('loading', newVal); },
        rowCount: {
            immediate: true,
            handler(newVal, oldVal) {
                this.emitEvent('row-count', newVal);
                if (oldVal > 0 && newVal === 0)
                    this.emitEvent('row-count-went-to-zero');
            }
        },
        columnSelectorDialogVisible(newVal) {
            if (!newVal)
                return;
            this.$nextTick(() => callRefFunc(this, 'columnSelectSearchBox', 'focus'));
        },
        actionArgumentsPassedThroughProps: {
            deep: true,
            handler(newVal, oldVal) { if (!isEqual(newVal, oldVal))
                this.fetchData(); }
        },
        localFilterModel: {
            deep: true,
            handler(newVal, oldVal) {
                if (!this.initializationInProcess && !isEqual(cloneDeep(newVal || null), cloneDeep(oldVal || null))) {
                    this.paginationObject = Object.assign(Object.assign({}, (this.paginationObject || {})), { page: 1, count: -1 }); // this is needed because this number will be sent to server, to make it use as a total row count instead of recalculating it.  But since we're changing the filter, the row count may change.  Thus, we must signal to the server that we actually want it to recalculate the row count (given the new filter).  And we do so by making pagination.page (into which paginationObject.rowsNumber gets assigned at time of request) to be -1
                    this.fetchData();
                }
            }
        },
        startingFilterModelPassedThroughProps: {
            deep: true,
            handler(newVal, oldVal) {
                if (!this.initializationInProcess && !isEqual(newVal, oldVal)) {
                    this.localFilterModel = transformFilterModelFromV1ToV0IfNotYet(newVal);
                    this.paginationObject = Object.assign(Object.assign({}, (this.paginationObject || {})), { page: 1, count: -1 }); // this is needed because this number will be sent to server, to make it use as a total row count instead of recalculating it.  But since we're changing the filter, the row count may change.  Thus, we must signal to the server that we actually want it to recalculate the row count (given the new filter).  And we do so by making pagination.page (into which paginationObject.rowsNumber gets assigned at time of request) to be -1
                    this.fetchData();
                }
            }
        },
        /* startingFilterModelV0: {
          deep: true,
          handler (newVal) { this.localFilterModel = (cloneDeep(newVal) || {}) }
        }, */
        localSortingModel: {
            deep: true,
            handler(newVal) {
                if (this.isServerSidePagination && !this.initializationInProcess)
                    this.fetchData();
            }
        },
        paginationObjectInStore: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (Number((newVal || {}).count) > 0) {
                    this.paginationObject = {
                        page_size: newVal.page_size,
                        page: newVal.page,
                        count: newVal.count,
                        pages: newVal.pages
                    };
                }
            }
        },
        grandTotalsRowInStore: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (newVal)
                    this.grandTotalsRow = Object.assign({}, newVal);
            }
        },
        currentMode_reinitialization_requested: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal === true && this.currentMode.localEntityName === this.localEntityName) {
                    this.initialize();
                }
                else {
                    Store.commit('mode/SET_CURRENT_MODE', Object.assign(Object.assign({}, (this.currentMode || {})), { reinitializationRequested: false }));
                }
            }
        },
        'currentMode.fetchDataRequested': {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal === true && this.currentMode.localEntityName === this.localEntityName) {
                    this.fetchData();
                }
                else {
                    Store.commit('mode/SET_CURRENT_MODE', Object.assign(Object.assign({}, (this.currentMode || {})), { fetchDataRequested: false }));
                }
            }
        },
        localEntityNameProp: {
            immediate: true,
            handler() { this.initialize(); }
        },
        columnsSource: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
                if (!oldVal || !isEqual(newVal, oldVal)) {
                    this.initializeColumns(newVal);
                }
            }
        }
    },
    created() {
        this.fetchData = debounce(this.fetchData, 50); // debouncing is needed because multiple things can trigger refresh of data. and sometimes they change at the same time (e.g., when a different menu item is clicked, and a new vuex module and filters are used for GenericTable component that is already initialized)
        this.handleCellChange = debounce(this.handleCellChange, 50);
        this.handleBlurOnFilterTextInput = debounce(this.handleBlurOnFilterTextInput, 50);
        this.initializeColumns = debounce(this.initializeColumns, 200);
        this.tryProcessingColumnMovement = debounce(this.tryProcessingColumnMovement, 100);
        // this.initialize = debounce(this.fetchData, 50)
        // this.initialize() // now this is handled in currentMode.reinitializationRequested watcher
    },
    methods: {
        getExpansionRowComponent(props) {
            const cols = this.columnsLocalCopy.filter(col => col.expansionRowComponent !== undefined);
            if (arrayLength(cols) > 1)
                console.warn('There are more than one columns with expansionRowComponent defined.  Only the first one will be used.');
            else if (arrayLength(cols) === 0)
                console.warn('There are no columns with expansionRowComponent defined.  Returning undefined.');
            const col = cols[0];
            if (!col || !col.expansionRowComponent)
                return undefined;
            const componentWithProps = col.expansionRowComponent(props, this);
            if (!componentWithProps)
                return undefined;
            const componentWithProps2 = {
                component: componentWithProps.component,
                componentProps: invokeOrIdentity(componentWithProps.componentProps, props)
            };
            return componentWithProps2;
        },
        startCase,
        camelCase,
        invokeOrIdentity,
        ensureArray,
        invokeOrUndefined,
        fromPgToLocalSorting,
        getter,
        highlighter,
        getDisplayValueFromEnrichedData,
        getValueFromEnrichedData,
        fileUploadHandler,
        callRefFunc,
        // start gettersOfCalculatedStylesAndClasses
        getRowStyles,
        getCellContentStyles,
        getCellContentClasses,
        getTdStyles,
        getCellDivClasses,
        getCellDivStyles,
        // end gettersOfCalculatedStylesAndClasses
        toggleExpansionOfRowWithId(id) {
            toggleItemPresenceInArray(this.idsOfExpandedRows, id);
        },
        toggleAllExpansionRows() {
            if (this.idsOfExpandedRows.length === 0) {
                this.idsOfExpandedRows = this.enrichedSourceData.map(r => r.id);
            }
            else {
                this.idsOfExpandedRows = [];
            }
        },
        // #region accessors for state, computed, and methods
        getPropsKeys() { return Object.keys(this.$props); },
        getStateKeys() { return Object.keys(this.$data); },
        getComputedKeys() { return Object.keys(this.$options.computed || {}); },
        getMethodsKeys() { return Object.keys(this.$options.methods || {}); },
        getPropByKey(key) {
            const result = this[key];
            return result;
        },
        getStateByKey(key) { return this.$data[key]; },
        getComputedByKey(key) { return this[key]; },
        getMethodByKey(key) { var _a; return (_a = this.$options.methods) === null || _a === void 0 ? void 0 : _a[key]; },
        getJsTypeOfKey(key) {
            const jsType = typeof this[key];
            if (jsType === 'object' && Array.isArray(this[key]))
                return 'array';
            return jsType;
        },
        setStateByKey(key, value) { this.$set(this, key, value); },
        // #endregion accessors for state, computed, and methods
        // This is a simple wrapper for this.$emit.  It is done for ensuring typescript
        emitEvent(eventName, emittedValue) {
            this.$emit(eventName, emittedValue);
            if (this.eventHandlers && this.eventHandlers[eventName] && typeof this.eventHandlers[eventName] === 'function') {
                try {
                    // @ts-ignore
                    this.eventHandlers[eventName](emittedValue);
                }
                catch (e) {
                    console.error('Error in event handler', e);
                }
            }
        },
        openViewCodeDialog(params) {
            callRefFunc(this, 'ViewCodeDialog', 'openDialog', params);
        },
        initializeColumns(columnsSource) {
            this.columnsLocalCopy = cloneDeep(columnsSource || this.columnsSource);
            // mixining in the last user-saved order of columns, if it exists
            if (this.tableId) {
                const lastForTable = this.lastResultOfUserInducedChangesToTableDisplay;
                if (lastForTable === null || lastForTable === void 0 ? void 0 : lastForTable.columnsOrder) {
                    this.columnsLocalCopy.sort((a, b) => {
                        var _a, _b;
                        if (!lastForTable)
                            return 0;
                        if (!lastForTable.columnsOrder)
                            return 0;
                        if (!Array.isArray(lastForTable.columnsOrder))
                            return 0;
                        if (lastForTable.columnsOrder.length === 0)
                            return 0;
                        if (!a || !b || !a.name || !b.name)
                            return 0;
                        const idxA = ((_a = lastForTable === null || lastForTable === void 0 ? void 0 : lastForTable.columnsOrder) === null || _a === void 0 ? void 0 : _a.indexOf(a === null || a === void 0 ? void 0 : a.name)) || -1;
                        const idxB = ((_b = lastForTable === null || lastForTable === void 0 ? void 0 : lastForTable.columnsOrder) === null || _b === void 0 ? void 0 : _b.indexOf(b === null || b === void 0 ? void 0 : b.name)) || -1;
                        if (idxA === -1 && idxB === -1)
                            return 0;
                        if (idxA === -1)
                            return 1;
                        if (idxB === -1)
                            return -1;
                        return idxA - idxB;
                    });
                    this.columnsLocalCopy.forEach((col, idx) => { col.displayOrder = idx; }); // See comment 20210704-1 for explaination why this is here
                }
            }
            this.columnsLocalCopy.forEach((col) => {
                if (col.hideWhenDisplaying === undefined)
                    Vue.set(col, 'hideWhenDisplaying', false);
            });
        },
        getCellPropsObject(props, col) {
            if (Object.keys(props).length === 0 || Object.keys(col).length === 0)
                debugger;
            return Object.assign(Object.assign({}, props), { col });
        },
        addSortingStep() {
            this.localSortingModelDialogValueHolder.push({ application_order: this.localSortingModelDialogValueHolder.length, field: this.columnsFilteredAndEnriched[0].field, direction: 'asc' });
        },
        toggleDirection(dir) { return dir === 'asc' ? 'desc' : 'asc'; },
        toggleColumnMembershipInColumnsToExcludeFromDownload(input, col) {
            if (input === true) {
                this.columnsToExcludeFromDownload = this.columnsToExcludeFromDownload.filter((r) => r !== (col.label || col.downloadLabel));
            }
            else {
                this.columnsToExcludeFromDownload.push((typeof col.label === 'function' ? col.label() : col.label) || col.downloadLabel || 'Error: Both col.label and col.downloadLabel were empty');
            }
        },
        /**
         * This function exists becuase at some point we allowed passing GenericTableProps via store mode/currentMode object.
         * That way of passing props may or may not need to be fully depriacated. Unclear as of 1/28/2024.
         * I suspect that some of the props passed via store mode/currentMode object may still be needed, but I'm not sure which ones.
         */
        combineProp(propName) {
            // @ts-ignore
            const componentProp = this[propName];
            const propPassedFromEntityDefinition = this.genericTablePropsPassedFromEntityDefinition[propName];
            // passing GenericTableProps via store mode/currentMode object has been deprecated since mid 2020
            // @ts-ignore
            const propPassedThroughDepricatedWayOfCurrentMode = this.currentMode[propName];
            return componentProp || propPassedFromEntityDefinition || propPassedThroughDepricatedWayOfCurrentMode;
        },
        cellContentStyles(cellProps) {
            let res = getCellContentStyles(cellProps);
            res = Object.assign(Object.assign({}, res), getCssPropertiesFromAmbiguousStyleInput('min-height:26px;display:flex;align-items:center'));
            return res;
        },
        rowStyles(props) {
            return getRowStyles(props, this);
        },
        takeSnapshotOfMainTable() {
            const mainTable = document.getElementById('gt');
            const fileName = `${this.computedTitle} - retrieved on ${dateToISODateTime(new Date())}`;
            downloadHTMLElementAsPng(mainTable, fileName);
        },
        borderLeftIfNeededWhileMovingAnotherColumn(col) {
            var _a, _b;
            return ((_a = this.columnOverWhichAnotherColumnIsBeingDragged) === null || _a === void 0 ? void 0 : _a.name) === col.name && ((_b = this.columnBeingDragged) === null || _b === void 0 ? void 0 : _b.name) !== col.name
                ? { 'borderLeft': '2px solid var(--theme-grey-80)', 'transition': 'border-left 0.3s' }
                : { 'borderLeft': 'none', 'transition': 'border-left 0.3s' };
        },
        initiateColumnDragging(col) {
            if (this.disableColumnDraggingPassedThroughProps)
                return;
            this.columnBeingDragged = col;
            const timeOfStartDragging = Date.now();
            window.addEventListener('mouseup', e => {
                if (Date.now() - timeOfStartDragging < 300) {
                    this.columnBeingDragged = undefined; // this is to prevent accidental column dragging when user is just clicking on column header to sort it
                }
            }, { once: true });
        },
        handleColumnHeaderMouseOver(col) {
            if (this.columnBeingDragged) {
                this.columnOverWhichAnotherColumnIsBeingDragged = col;
            }
        },
        handleColumnHeaderMouseUp(col) {
            if (this.columnBeingDragged) {
                this.columnOnToWhichAnotherColumnDraggingEnded = col;
                this.tryProcessingColumnMovement();
            }
        },
        tryProcessingColumnMovement() {
            if (this.columnBeingDragged === undefined)
                return;
            const colA = Object.assign({}, this.columnBeingDragged);
            const colB = Object.assign({}, this.columnOnToWhichAnotherColumnDraggingEnded);
            if (colA && colB && colA.name && colB.name && colA.name !== colB.name) {
                const oldIdx = this.columnsLocalCopy.findIndex((c) => c.name === colA.name);
                const newIdx = this.columnsLocalCopy.findIndex((c) => c.name === colB.name);
                if (newIdx === -1) { // if dropped on last column then newIdx will be -1
                    this.columnsLocalCopy.splice(oldIdx, 1);
                    this.columnsLocalCopy.push(colA);
                }
                else if (oldIdx < newIdx) {
                    this.columnsLocalCopy.splice(oldIdx, 1);
                    this.columnsLocalCopy.splice(newIdx - 1, 0, colA);
                }
                else {
                    this.columnsLocalCopy.splice(oldIdx, 1);
                    this.columnsLocalCopy.splice(newIdx, 0, colA);
                }
            }
            // saving user-induced changes to table structure
            // @ts-ignore
            this.lastResultOfUserInducedChangesToTableDisplay = Object.assign(Object.assign({}, this.lastResultOfUserInducedChangesToTableDisplay), { columnsOrder: this.columnsLocalCopy.map(c => c.name) });
            /** 20210704-1
             * The following is done because the last step of determining the order of columns uses Column.displayOrder property, when it is set in entity definition. (This is done in computed property columnsFilteredAndEnriched)
             * Therefore, for tables that have displayOrder, if we don't do the following, then the column order manual changes will be overriden by displayOrder
             */
            this.columnsLocalCopy.forEach((col, idx) => { col.displayOrder = idx; });
            this.columnBeingDragged = undefined;
            this.columnOverWhichAnotherColumnIsBeingDragged = undefined;
            this.columnOnToWhichAnotherColumnDraggingEnded = undefined;
        },
        injectIntoLocalFilterModel(filterModelToInject) {
            for (const fc of filterModelToInject) {
                this.addToLocalFilterModel({ name: fc.field, field: fc.field }, fc.predicate, fc.value);
            }
        },
        setLocalData(data) {
            this.localData = data;
        },
        handleClickOnRefreshButton() {
            return __awaiter(this, void 0, void 0, function* () {
                fullScreenLoading.show({ message: 'Refreshing data' });
                this.paginationObject.count = -1; // this makes sure that we don't send to server our current belief about count of rows (generic select rpc controller uses it as "cache" value), and get the row count recalculated
                this.fetchData_notDebounced()
                    .then(fullScreenLoading.hide);
            });
        },
        openSaveTableViewDialog() {
            callRefFunc(this, 'SaveTableViewDialog', 'open', this);
        },
        getColLabel(col) {
            return (typeof col.label === 'function' ? col.label() : col.label);
        },
        colHideWhenDisplaying(col) {
            return ((typeof col.hideWhenDisplaying === 'function' && col.hideWhenDisplaying(this)) ||
                (typeof col.hideWhenDisplayingInTable === 'function' && col.hideWhenDisplayingInTable(this)) ||
                (typeof col.hideWhenDisplaying === 'boolean' && col.hideWhenDisplaying) ||
                (typeof col.hideWhenDisplayingInTable === 'boolean' && col.hideWhenDisplayingInTable));
        },
        handleBlurOnFilterTextInput(col, filterItem) {
            this.addToLocalFilterModel(col, filterItem.type, this.currentFilterEditValueHolder);
            this.currentFilterEditValueHolder = '';
        },
        getHtmlDescriptionOfFilterField(field) {
            const filters = this.localFilterModel;
            let res = '';
            const col = this.columnsLocalCopy.find((col) => (col.field || '') === field);
            res += '<div style="white-space:nowrap;">';
            res += ('<b>' + (col ? col.label : startCase(field)) + '</b>: ');
            let keyIndex = 0;
            for (const predicate in filters[field]) {
                if (keyIndex > 0)
                    res += ' AND ';
                res += (startCase(predicate) + ' ');
                const tmp = filters[field][predicate];
                const filterValue = (tmp === undefined) ? '' : tmp;
                if (Array.isArray(filterValue)) {
                    res += '[';
                    for (const val of filterValue) {
                        res += ' ' + (col ? getDisplayValueFromEnrichedData(col, { [field]: val }) : val);
                    }
                    res += ' ]';
                }
                else {
                    if (col) {
                        const displayValue = getDisplayValueFromEnrichedData(col, { [field]: filterValue });
                        res += (displayValue !== undefined && displayValue !== '') ? displayValue : filterValue;
                    }
                    else {
                        res += filterValue;
                    }
                }
                keyIndex++;
            }
            return res;
        },
        setColumnDisplayTimeZone(cellProps, displayTimeZone) {
            const col = cellProps.col;
            const colLocalCopy = this.columnsLocalCopy.find((r) => r.name === col.name);
            if (!colLocalCopy)
                return;
            Vue.set(colLocalCopy, 'displayTimeZone', displayTimeZone.name);
        },
        cellIsEditable(cellProps) {
            const { col } = cellProps;
            if (this.rowIsLockedFunctionPassedThroughProps && this.rowIsLockedFunctionPassedThroughProps(cellProps))
                return false;
            if (!this.updatingRecordsIsEnabled)
                return false;
            if (!col)
                debugger;
            if (typeof col.editable === 'function')
                return col.editable(cellProps);
            if (typeof col.editable === 'boolean')
                return col.editable;
            if (col.inlineEdit !== undefined)
                return invokeOrIdentity(col.inlineEdit, cellProps);
            return false;
        },
        getAvailableLocalFilterTypes(col) {
            if (!Array.isArray(col.uiFilterTypes))
                return [];
            let fTypes = [];
            // eslint-disable-next-line no-unused-vars
            const textFilters = [{ type: 'contains', label: 'Contains...', filterGroup: '' }, { type: 'doesNotContain', label: 'Does not contain...' }, { separator: true }, { type: 'beginsWith', label: 'Begins With...' }, { type: 'endsWith', label: 'Ends With...' }, { separator: true }, { type: 'equals', label: 'Equals...' }, { type: 'doesNotEqual', label: 'Does not equal...' }];
            textFilters.forEach((r) => { r.filterGroup = 'textFilters'; });
            const dateFilters = [{ type: 'equals', label: 'Equals...', filterGroup: '' }, { separator: true }, { type: 'before', label: 'Before...' }, { type: 'after', label: 'After...' }, { separator: true }, { type: 'tomorrow', label: 'Tomorrow' }, { type: 'today', label: 'Today' }, { type: 'yesterday', label: 'Yesterday' }, { separator: true }, { type: 'nextWeek', label: 'Next Week' }, { type: 'thisWeek', label: 'This Week' }, { type: 'lastWeek', label: 'Last Week' }, { separator: true }, { type: 'nextMonth', label: 'Next Month' }, { type: 'thisMonth', label: 'This Month' }, { type: 'lastMonth', label: 'Last Month' }, { separator: true }, { type: 'past30days', label: 'Past 30 Days' }, { type: 'past7days', label: 'Past 7 Days' }, { separator: true }, { type: 'nextQuarter', label: 'Next Quarter' }, { type: 'thisQuarter', label: 'This Quarter' }, { type: 'lastQuarter', label: 'Last Quarter' }, { separator: true }, { type: 'nextYear', label: 'Next Year' }, { type: 'thisYear', label: 'This Year' }, { type: 'lastYear', label: 'Last Year' }, { separator: true }, { type: 'yearToDate', label: 'Year to Date' }];
            dateFilters.forEach((r) => { r.filterGroup = 'dateFilters'; });
            const numberFilters = [{ type: 'equals', label: 'Equals...', filterGroup: '' }, { type: 'doesNotEqual', label: 'Does Not Equal...' }, { separator: true }, { type: 'greaterThan', label: 'Greater Than...' }, { type: 'greaterThanOrEqualTo', label: 'Greter Than or Equal To...' }, { type: 'lessThan', label: 'Less Than...' }, { type: 'lessThanOrEqualTo', label: 'Less Than or Equal To...' }, { separator: true }, { type: 'topX', label: 'Top X...' }, { type: 'bottomX', label: 'Bottom X...' }, { type: 'belowAverage', label: 'Below Average' }, { type: 'aboveAverage', label: 'Above Average' }];
            numberFilters.forEach((r) => { r.filterGroup = 'numberFilters'; });
            const getAvailableValuesDisplayLabels = (col) => {
                return [...new Set(this.enrichedSourceData.map((row) => getDisplayValueFromEnrichedData(col, row)))];
            };
            const getAllValues = (col) => {
                if (col.isArray) {
                    const valSet = new Set();
                    for (const row of this.enrichedSourceData) {
                        if (Array.isArray(row[col.field])) {
                            row[col.field].forEach((val) => valSet.add(val));
                        }
                    }
                    return [...valSet];
                }
                else {
                    return [...new Set(this.enrichedSourceData.map((row) => getValueFromEnrichedData(col, row)))];
                }
            };
            const getLabelsWithValuesArr = (col) => {
                const rows = this.enrichedSourceData.map((row) => ({ value: getValueFromEnrichedData(col, row), label: getDisplayValueFromEnrichedData(col, row), rawDataValue: row[col.field] }));
                let labels = [];
                for (const row of rows) {
                    if (col.isArray) {
                        labels = labels.concat(row.rawDataValue);
                    }
                    else {
                        labels.push(row.label);
                    }
                }
                const distinctLabels = [...new Set(labels)].filter(el => el).sort((a, b) => String(a).localeCompare(String(b)));
                const b = distinctLabels.map((label) => {
                    if (col.isArray) {
                        return { label, values: [label] };
                    }
                    else {
                        return { label, values: [...new Set(rows.filter((r) => String(r.label) === String(label)).map((r) => String(r.value === undefined ? '' : r.value)))] };
                    }
                });
                if (Array.isArray(this.remoteDistinctLabelsHolder[col.field])) {
                    return b.concat(this.remoteDistinctLabelsHolder[col.field].filter((r) => !distinctLabels.includes(String(r.label || r))));
                }
                else {
                    return b;
                }
            };
            for (const f of col.uiFilterTypes || []) {
                if (f === 'textFilters')
                    fTypes = [...fTypes, ...textFilters];
                if (f === 'dateFilters')
                    fTypes = [...fTypes, ...dateFilters];
                if (f === 'numberFilters')
                    fTypes = [...fTypes, ...numberFilters];
                if (f === 'selectedValuesFilter') {
                    const selectedValuesFilter = {
                        filterGroup: 'selectedValuesFilter',
                        type: 'containedIn',
                        label: 'Selected values',
                        availableValuesDisplayLabels: getAvailableValuesDisplayLabels(col),
                        allValues: getAllValues(col),
                        labelsWithValuesArr: getLabelsWithValuesArr(col)
                    };
                    fTypes = [...fTypes, selectedValuesFilter];
                }
            }
            return fTypes;
        },
        getColByField(field) { return this.columnsFilteredAndEnriched.find((r) => r.field === field); },
        getColByName(field) { return this.columnsFilteredAndEnriched.find((r) => r.name === name); },
        selectOptionsGetter(col) {
            if (!Array.isArray(col.references) || !col.references)
                return [];
            if (col.references[0].name === undefined) {
                console.error('col.references[0].name === undefined');
                return [];
            }
            // @ts-ignore
            return col.references.filter((r) => { var _a; return !this.currentSelectFilter || this.currentSelectFilter === '' || ((_a = r === null || r === void 0 ? void 0 : r.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(this.currentSelectFilter)); });
        },
        allFilterValuesInColumnAreSelected(col, filterItem) {
            const lfm = this.localFilterModel[col.name];
            if (!lfm || !lfm.containedIn)
                return true;
            const selValues = lfm.containedIn.map((s) => String(s));
            const t = ((this.remoteDistinctLabelsHolder[col.field] || []).map((r) => r.values) || []).flat();
            if (Array.isArray(t)) {
                if (t.some((s) => !selValues.includes(String(s || 'null'))))
                    return false;
            }
            return filterItem.allValues.every((r) => selValues.includes(String(r)));
        },
        get(x, y, z) { return get(x, y, z); },
        // column display shape logic ends
        handleMovementInSelectedValuesFilter(e, i, cellProps, filterItem) {
            e.preventDefault();
            e.stopPropagation();
            const { col } = cellProps;
            const len = (this.filterForSearchTerm(cellProps, filterItem.labelsWithValuesArr, this.filterValueSearchTerm[col.field]) || []).length;
            const newVal = this.selectedValuesFilterManualIndex + i;
            if (this.selectedValuesFilterManualIndex === 0 && newVal === -1) {
                this.selectedValuesFilterManualIndex = -2; // -2 is "Select all" item
            }
            else if (this.selectedValuesFilterManualIndex === -2 && newVal === -1) {
                this.selectedValuesFilterManualIndex = 0;
            }
            else if (newVal > len - 1) {
                this.selectedValuesFilterManualIndex = 0;
            }
            else if (newVal < -2) {
                // do nothing
            }
            else {
                this.selectedValuesFilterManualIndex = newVal;
            }
        },
        handleEnterPressOnFilterValueSearchInput(e, cellProps, filterItem) {
            e.preventDefault();
            e.stopPropagation();
            const { col } = cellProps;
            if (this.selectedValuesFilterManualIndex === -2) {
                this.handleSelectAllOnFilter(!this.allFilterValuesInColumnAreSelected(col, filterItem), col);
            }
            else {
                this.selectOnlyThisFilterItem(col, this.filterForSearchTerm(cellProps, filterItem.labelsWithValuesArr, this.filterValueSearchTerm[col.field])[this.selectedValuesFilterManualIndex]);
                this.selectedValuesFilterManualIndex = -1; // selector resets to invisible.  ...doesn't reset for -2, as after Select All, we want the user to be able to press on it again
            }
            this.forceSelectedValuesFilterSearchBoxToShow = true;
        },
        shiftDateFilterAbstract(e, col, incrementType, direction) {
            e.stopPropagation();
            e.preventDefault();
            let count;
            let unit;
            const directionNumber = (direction === 'back') ? -1 : 1;
            if (col.dateIncrementStep) {
                count = col.dateIncrementStep[incrementType].count * directionNumber;
                unit = col.dateIncrementStep[incrementType].unit;
            }
            else {
                count = 1 * directionNumber;
                unit = (incrementType === 'minor' ? 'day' : 'week');
            }
            this.shiftDateFilter(col, count, unit);
        },
        shiftDateFilter(col, count, unit) {
            const newModel = cloneDeep(this.localFilterModel);
            const filter = newModel[col.field];
            const getIncrementedDate = (val) => {
                const parsed = parseISO(val);
                let incrementedDate = new Date();
                if (unit === 'day') {
                    incrementedDate = addDays(parsed, count);
                }
                else if (unit === 'week') {
                    incrementedDate = addWeeks(parsed, count);
                }
                else if (unit === 'month') {
                    incrementedDate = addMonths(parsed, count);
                }
                else if (unit === 'quarter') {
                    incrementedDate = addQuarters(parsed, count);
                }
                else if (unit === 'year') {
                    incrementedDate = addYears(parsed, count);
                }
                const formatted = formatISO(incrementedDate, { representation: 'date' }) || 'Invalid date';
                return formatted;
            };
            const predicates = Object.keys(filter);
            if (predicates.length === 0)
                return void 0;
            for (const predicate of predicates) {
                const curVal = filter[predicate];
                if (Array.isArray(curVal)) {
                    const arr = [];
                    curVal.forEach(val => arr.push(getIncrementedDate(val)));
                    filter[predicate] = arr;
                }
                else {
                    filter[predicate] = getIncrementedDate(curVal);
                }
            }
            this.localFilterModel = Object.assign(Object.assign({}, cloneDeep(this.localFilterModel)), { [col.field]: filter });
        },
        handleFilterTypingInput(e) { this.currentFilterEditValueHolder = e; },
        changePaginationPage(changeType) {
            const { page, pages } = this.paginationObject;
            let newPage;
            if (changeType === 'first') {
                newPage = 1;
            }
            else if (changeType === 'previous') {
                newPage = page - 1;
            }
            else if (changeType === 'next') {
                newPage = page + 1;
            }
            else if (changeType === 'last') {
                newPage = pages || -1;
            }
            else if (typeof changeType === 'number') {
                newPage = changeType;
            }
            else {
                debugger;
                throw new Error('changePaginationPage() received an invalid changeType');
            }
            if (this.isServerSidePagination) {
                this.fetchData(this.paginationObject.page_size, newPage);
            }
            else {
                this.paginationObject.page = newPage;
            }
        },
        handleManualChangeOfRowsPerPage(val) {
            if (this.isServerSidePagination) {
                this.fetchData(val, 1);
            }
            else {
                this.paginationObject.page_size = val;
            }
        },
        setDialogComponentPlaceHolder(component, componentProps) {
            this.dialogComponentPlaceHolder = component;
            this.dialogComponentPlaceHolderProps = componentProps;
        },
        // exposed in GenericTableMethodsAccessor
        openDialog(component, componentProps, openDialogParams) {
            this.setDialogComponentPlaceHolder(component, componentProps);
            return this.$nextTick(() => callRefFunc(this, 'dialogComponentPlaceHolder', 'openDialog', openDialogParams));
        },
        // exposed in GenericTableMethodsAccessor
        getData() {
            return this.data;
        },
        resetColumnVisibilityAndOrderToDefaults() {
            this.lastResultOfUserInducedChangesToTableDisplay = Object.assign(Object.assign({}, this.lastResultOfUserInducedChangesToTableDisplay), { columnsToHide: [], columnsToShow: [], columnsOrder: [] });
            this.initializeColumns();
        },
        saveUserInducedChangesToTableStructure_toLocalStorage(col, e) {
            if (this.tableId) {
                const lastForTable = this.lastResultOfUserInducedChangesToTableDisplay;
                let columnsToHide = get(lastForTable, 'columnsToHide') || [];
                let columnsToShow = get(lastForTable, 'columnsToShow') || [];
                if (e /* i.e., show column */) {
                    columnsToShow.push(col.name);
                    columnsToHide = columnsToHide.filter(name => name !== col.name);
                }
                else /* i.e., hide column */ {
                    columnsToShow = columnsToShow.filter(name => name !== col.name);
                    columnsToHide.push(col.name);
                }
                // @ts-ignore
                lastForTable.columnsToHide = columnsToHide;
                // @ts-ignore
                lastForTable.columnsToShow = columnsToShow;
                this.lastResultOfUserInducedChangesToTableDisplay = lastForTable;
            }
        },
        setColumnVisibility(col, e) {
            try {
                const columns = [...this.columnsLocalCopy];
                const colIdx = columns.findIndex((c) => c.name === col.name);
                if (colIdx === -1)
                    return;
                const column = columns[colIdx];
                columns[colIdx] = setColumnVisibility(column, e);
                this.columnsLocalCopy = columns;
                this.saveUserInducedChangesToTableStructure_toLocalStorage(col, e);
            }
            catch (e) {
                console.error(e);
            }
        },
        setVisibilityOfAllColumns(e) {
            const newCols = [...this.columnsLocalCopy];
            const newCols2 = newCols.map((col) => { return setColumnVisibility(col, e); });
            this.columnsLocalCopy = newCols2;
            // note that we are NOT calling here this.saveUserInducedChangesToTableStructure_toLocalStorage(col, e). because setting visibility of all columns is not a user-induced change to table structure that we would like to save
        },
        filterForSearchTerm(cellProps, stack, needle) {
            const { col } = cellProps;
            if (!needle || needle === '') {
                if (col.references || col.possibleValues) {
                    const refArr = getColReferenceDataArray(col.references, this, cellProps).slice(0, 101);
                    const distinctLabels = [...(new Set(refArr.map(r => r.name || r)))];
                    if (refArr.length === distinctLabels.length) {
                        return refArr.map(r => ({ label: r.name || r || 'n/a', values: [r.id || r] }));
                    }
                    else {
                        return distinctLabels.map(label => ({ label, values: refArr.filter(r => (r.name || r) === label).map(r => r.id || r) }));
                    }
                }
                else {
                    return stack;
                }
            }
            const lcNeedle = getDisplayValue(col, { [col.field]: needle }).toLowerCase();
            let res = [];
            if ((stack[0] || {}).label !== undefined) {
                res = stack.filter((r) => String(r.label || '').toLowerCase().includes(lcNeedle));
            }
            else {
                res = stack.filter((r) => String(r).toLowerCase().includes(lcNeedle));
            }
            if (res.length > 0) {
                return res;
            }
            else {
                if (col.references && Array.isArray(col.references) && col.references.length > 0) {
                    const filteredRefTable = getColReferenceDataArray(col.references, this, cellProps).filter(r => r.name && r.name.toLowerCase().includes(needle));
                    if (filteredRefTable && filteredRefTable.length > 0) {
                        return filteredRefTable.map(r => ({ label: r.name, values: [r.id] }));
                    }
                    else {
                        return [];
                    }
                }
                else if (this.apiVersion === 1) {
                    const rdlh = this.remoteDistinctLabelsHolder[col.field];
                    const existingLabels = [
                        ...stack.map(r => r.label),
                        ...(Array.isArray(rdlh) ? (rdlh.map(r => r.label)) : [])
                    ];
                    const payload = {
                        filter_conditions: [
                            { field: col.field, predicate: 'contains', value: needle },
                            { field: col.field, predicate: 'notContainedIn', value: existingLabels }
                        ],
                        this_is_autocomplete_search: true,
                        need_only_columns: [col.field],
                        pagination: { page_size: 100 }
                    };
                    fetchRecords(this.localEntityName, deepmerge(this.fetchParamsToMixInPassedThroughProps, { payload, justReturnDataDontWriteToState: true })).then(response => {
                        var _a;
                        const labels = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.map(r => r[col.field])) || [];
                        if (labels.length > 0) {
                            const labelsUnique = [...new Set(labels)];
                            const values = labelsUnique.map(label => ({ label, values: [label] }));
                            Vue.set(this.remoteDistinctLabelsHolder, col.field, values);
                        }
                        return stack;
                    });
                }
            }
            return stack;
        },
        tableRequestHandler(e) {
            const pagination = (e.pagination || {});
            if (this.isServerSidePagination) {
                if (this.currentMode.fetchParams) {
                    this.currentMode.fetchParams.page = pagination === null || pagination === void 0 ? void 0 : pagination.page;
                    this.currentMode.fetchParams.page_size = pagination === null || pagination === void 0 ? void 0 : pagination.rowsPerPage;
                }
                else {
                    this.currentMode.fetchParams = { page: e.pagination.page, page_size: pagination === null || pagination === void 0 ? void 0 : pagination.rowsPerPage };
                }
                this.fetchData();
            }
        },
        cellClickHandler(cellProps, e) {
            const { col, row } = cellProps;
            if (col.isCode) {
                const params = {
                    // code: getDisplayValueFromEnrichedData(col, row),
                    code: getValueFromEnrichedData(col, row),
                    codeLanguage: col.codeLanguage || 'JSON',
                    callBackForSaving: this.cellIsEditable(cellProps) ? (newVal) => this.handleCellChange(newVal, cellProps) : undefined,
                    title: this.getColLabel(col)
                };
                callRefFunc(this, 'ViewCodeDialog', 'openDialog', params);
            }
            if (col.isWysiwyg) {
                const params = {
                    content: row['html_template'],
                    rawContent: getValue(col, row),
                    variables: row['default_vars'],
                    partials: row['partials'],
                    callBackForSaving: this.cellIsEditable(cellProps) ? (newVal) => this.handleCellChange(newVal, cellProps) : undefined,
                    title: this.getColLabel(col)
                };
                callRefFunc(this, 'EditHTMLDialog', 'openDialog', params);
            }
            // isDisplayFormatSelector is deprecated
            if (col.isDisplayFormatSelector) {
                const params = {
                    value: getValue(col, row),
                    callBackForSaving: this.cellIsEditable(cellProps) ? (newVal) => this.handleCellChange(newVal, cellProps) : undefined,
                    title: this.getColLabel(col)
                };
                callRefFunc(this, 'DisplayFormatSelector', 'openDialog', params);
            }
        },
        tryToOpenValueSelectorDialog(props, col, valueChangeCallback, ctx) {
            if (!this.updatingRecordsIsEnabled)
                return;
            if (!this.cellIsEditable(this.getCellPropsObject(props, col)))
                return;
            openValueSelectorDialog(this.getCellPropsObject(props, col), valueChangeCallback, ctx);
        },
        updateSelectFilter(val) { this.currentSelectFilter = val.toLowerCase(); },
        downloadCsv() {
            return __awaiter(this, void 0, void 0, function* () {
                this.downloadListDialogueIsVisible = false;
                fullScreenLoading.show({ message: 'Generating download file' });
                const fetchParams = deepmerge(this.getFetchDataParams(), {
                    payload: {
                        requested_download_format: 'csv',
                        need_only_columns: this.columnsToDownload.map(col => col.field),
                        do_not_need_count: true,
                        do_not_log_on_backend: true,
                        preferred_view_type: 'download_view'
                    },
                    justReturnDataDontWriteToState: true
                });
                fetchRecords(this.localEntityName, fetchParams)
                    .then(result => {
                    var _a;
                    const downloadLink = (_a = result.meta) === null || _a === void 0 ? void 0 : _a.download_link;
                    const hiddenElement = document.createElement('a');
                    hiddenElement.href = downloadLink;
                    hiddenElement.target = '_blank';
                    hiddenElement.download = `${this.computedTitle} - retrieved on ${dateToISODateTime(new Date())} ${this.localFiltersAreSet ? ' - local filters applied' : ''}.csv`;
                    hiddenElement.click();
                    fullScreenLoading.hide();
                });
            });
        },
        downloadCsvFromLocalData() {
            this.downloadListDialogueIsVisible = false;
            const src = [];
            const data = cloneDeep(this.data);
            const cols = this.columnsToDownload;
            for (const row of data) {
                const srcRow = {};
                for (const col of cols) {
                    if (['Human readable', 'Both human readable and database readable'].includes(this.downloadMode)) {
                        const val = getDisplayValueFromEnrichedData(col, row);
                        const label = this.getColLabel(col) || col.downloadLabel;
                        if (label)
                            srcRow[label] = (col.isCode ? JSON.stringify(val) : val) || ''; // for human readers we replace nulls with '' emtpy
                    }
                    if (['Database readable', 'Both human readable and database readable'].includes(this.downloadMode)) {
                        srcRow[col.field] = col.isCode ? JSON.stringify(getValueFromEnrichedData(col, row)) : getValueFromEnrichedData(col, row);
                    }
                }
                src.push(srcRow);
            }
            let res = Object.keys(src[0]).map((r) => `"${r}"`).join(',') + '\r\n';
            for (const row of src) {
                const rowValArr = [];
                for (const key in row)
                    rowValArr.push(row[key]);
                res += rowValArr.map((r) => `"${r}"`).join(',') + '\r\n';
            }
            const hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(res);
            hiddenElement.target = '_blank';
            hiddenElement.download = `${this.computedTitle} - retrieved on ${dateToISODateTime(new Date())} ${this.localFiltersAreSet ? ' - local filters applied' : ''}.csv`;
            hiddenElement.click();
        },
        removeSelectedValuesFilterFromColumn(col) {
            // @ts-ignore
            this.localFilterModel[col.name] = omit(this.localFilterModel[col.name], ['containedIn']);
        },
        addToLocalFilterModel(col, filterPredicate, value, options = []) {
            var _a, _b;
            let newModel = cloneDeep(this.localFilterModel);
            // remove filter type and column if filter is set to empty
            if (value === null || value === undefined || String(value) === '') {
                if (newModel) {
                    newModel = omit(newModel, col.name);
                    this.localFilterModel = newModel;
                }
                return;
            }
            // This section removes other set filters of the same type as new filter, unless otherwise requested
            const availableDateFilters = this.getAvailableLocalFilterTypes(col).filter((r) => r.filterGroup === 'dateFilters');
            const availableNumberFilters = this.getAvailableLocalFilterTypes(col).filter((r) => r.filterGroup === 'numberFilters');
            if (availableDateFilters.map((r) => r.type).includes(filterPredicate) && Boolean(newModel[col.name]) && !options.includes('do not reset existing date filters'))
                availableDateFilters.forEach((r) => { Vue.delete(newModel[col.name], r.type); });
            if (availableNumberFilters.map((r) => r.type).includes(filterPredicate) && Boolean(newModel[col.name]) && !options.includes('do not reset existing number filters'))
                availableNumberFilters.forEach((r) => { Vue.delete(newModel[col.name], r.type); });
            if (['belowAverage', 'aboveAverage'].includes(filterPredicate)) {
                const mode = { 'belowAverage': 'lessThan', 'aboveAverage': 'greaterThan' };
                const column = this.enrichedSourceData.map((r) => Number(r[col.field]));
                const avg = column.reduce((a, b) => Number(a) + Number(b), 0) / column.length;
                this.addToLocalFilterModel(col, mode[filterPredicate], avg);
                return;
            }
            if (['topX', 'bottomX'].includes(filterPredicate)) {
                const mode = { topX: ['desc', 'greaterThanOrEqualTo'], bottomX: ['asc', 'lessThanOrEqualTo'] };
                // @ts-ignore
                const cutOff = orderBy(this.enrichedSourceData.filter((r) => r[col.field] !== null && r[col.field] !== undefined), [col.field], [mode[filterPredicate][0]])[value - 1][col.field];
                this.addToLocalFilterModel(col, mode[filterPredicate][1], cutOff);
                // note that we don't have here "return true", which  is different from similar expressions in this block.  That is because we do want to have topX and bottomX values be written down into the model, so that users sees her input
            }
            if (['today', 'tomorrow', 'yesterday'].includes(filterPredicate)) {
                const offset = { today: 0, tomorrow: 1, yesterday: -1 };
                this.addToLocalFilterModel(col, 'equals', dateToISODate(addDays(new Date(), offset[filterPredicate])));
                return;
            }
            // @ts-ignore
            const periodFilterTypes = product(['this', 'next', 'last'], ['Week', 'Month', 'Quarter', 'Year']).map((r) => r.join(''));
            if (periodFilterTypes.includes(filterPredicate)) {
                const prefix = filterPredicate.slice(0, 4);
                const period = filterPredicate.slice(4, filterPredicate.length).toLowerCase();
                const offset = { 'this': 0, next: 1, last: -1 };
                const periodFunctions = {
                    week: { start: startOfWeek, end: endOfWeek },
                    month: { start: startOfMonth, end: endOfMonth },
                    quarter: { start: startOfQuarter, end: endOfQuarter },
                    year: { start: startOfYear, end: endOfYear },
                };
                const startFn = (_a = periodFunctions[period]) === null || _a === void 0 ? void 0 : _a.start;
                const endFn = (_b = periodFunctions[period]) === null || _b === void 0 ? void 0 : _b.end;
                if (startFn) {
                    const startDate = addDays(startFn(new Date()), offset[prefix] * 7); // Modify period offset as needed
                    const endDate = addDays(endFn(new Date()), offset[prefix] * 7); // Modify period offset as needed
                    this.addToLocalFilterModel(col, 'after', startDate.toISOString().split('T')[0]);
                    this.addToLocalFilterModel(col, 'before', endDate.toISOString().split('T')[0], ['do not reset existing date filters']);
                }
                return;
            }
            if (['past7days', 'past30days'].includes(filterPredicate)) {
                const offset = { 'past7days': todayMinus7Days, 'past30days': todayMinus30Days }[filterPredicate];
                this.addToLocalFilterModel(col, 'after', offset);
                this.addToLocalFilterModel(col, 'before', tomorrow, ['do not reset existing date filters']); // do not reset existing date filters option is needed so that the action one line above doesn't get cancelled
                return;
            }
            if (filterPredicate === 'yearToDate') {
                this.addToLocalFilterModel(col, 'after', dateToISODate(startOfYear(new Date())));
                this.addToLocalFilterModel(col, 'before', getTomorrow(), ['do not reset existing date filters']); // do not reset existing date filters option is needed so that the action one line above doesn't get cancelled
                return;
            }
            if (!newModel[col.name])
                Vue.set(newModel, col.name, {});
            Vue.set(newModel[col.name], filterPredicate, String(value)); // it is unclear why, but if we replace String(value) with just value (as logical and was here originally), then if value is number, then reactivity doesn't get triggered
            this.localFilterModel = newModel;
        },
        updateLocalSetFilter(col, item, isSelected) {
            var _a;
            this.paginationObject.page = 1;
            const newModel = cloneDeep(this.localFilterModel);
            // @ts-ignore
            if (!newModel[col.name])
                newModel[col.name] = {};
            if (!newModel[col.name].containedIn)
                newModel[col.name]['containedIn'] = (_a = this.getAvailableLocalFilterTypes(col).find((r) => r.type === 'containedIn')) === null || _a === void 0 ? void 0 : _a.allValues;
            if (isSelected)
                newModel[col.name].containedIn.push(...ensureArray(item === null || item === void 0 ? void 0 : item.values));
            if (!isSelected)
                newModel[col.name].containedIn = newModel[col.name].containedIn.map((s) => String(s)).filter((r) => !item.values.includes(String(r)));
            if (newModel[col.name].containedIn.length === 0)
                newModel[col.name].containedIn.push(-999); // this is a hack needed to maintain reactivity when the list becomes empty.  Without it, empty containedIn filter doesn't impact data, while it should be returing empty data set
            this.localFilterModel = newModel;
        },
        selectOnlyThisFilterItem(col, item) {
            let newModel = cloneDeep(this.localFilterModel);
            this.paginationObject.page = 1;
            // if filter was selected as single value of id or native_id, it is logical to assume that user does not want any other filters to be enforeced.  That is why we reset all filters before setting the new filter
            if (['id', 'native_id'].includes(String(col.name)))
                newModel = {};
            if (!newModel[col.name])
                Vue.set(newModel, col.name, {});
            newModel[col.name]['containedIn'] = [];
            this.localFilterModel = newModel;
            if (['number', 'string', 'boolean'].includes(typeof item)) {
                this.updateLocalSetFilter(col, { values: [item] }, true);
            }
            else {
                this.updateLocalSetFilter(col, item, true);
            }
        },
        filterOutThisFilterItem(col, item) {
            if (['number', 'string', 'boolean'].includes(typeof item)) {
                this.updateLocalSetFilter(col, { values: [String(item)] }, false);
            }
            else {
                this.updateLocalSetFilter(col, String(item), false);
            }
        },
        handleSelectAllOnFilter(selected, col) {
            const newModel = cloneDeep(this.localFilterModel);
            if (!selected) {
                if (!newModel[col.name])
                    Vue.set(newModel, col.name, {});
                Vue.set(newModel[col.name], 'containedIn', []);
                newModel[col.name].containedIn.push(-999); // this is a hack needed to maintain reactivity when the list becomes empty.  Without it, empty containedIn filter doesn't impact data, while it should be returing empty data set
            }
            if (selected) {
                Vue.set(newModel, col.name, null);
            }
            this.localFilterModel = newModel;
        },
        setLocalSortingModel(value) {
            this.localSortingModel = [...(value || [])];
        },
        addToLocalSortingModel(col, direction) {
            if (!Array.isArray(this.localSortingModel))
                this.setLocalSortingModel([]);
            this.setLocalSortingModel(this.localSortingModel.filter(r => r.field !== col.field)); // remove sorting items for the same field
            const maxApplicationOrder = Math.max(...this.localSortingModel.map(sm => sm.application_order || 0));
            this.setLocalSortingModel([...this.localSortingModel, { application_order: maxApplicationOrder + 1, field: col.field, direction }]);
        },
        removeFromLocalSortingModel(col) {
            this.setLocalSortingModel(this.localSortingModel.filter(sortingMember => sortingMember.field !== col.field));
        },
        resetColFilters(col) {
            this.localFilterModel = omit(this.localFilterModel, [col.name]);
        },
        resetColFilter(col, filterPredicate) { Vue.delete(this.localFilterModel[col.name], filterPredicate); },
        resetAllFilters() {
            this.localFilterModel = {};
            this.fetchData();
        },
        toggleFullscreen() { this.isFullscreen = !this.isFullscreen; },
        actingUserHasControlledAction(x) {
            return Store.getters['actingUser/actingUserHasControlledAction'](x);
        },
        toggleSelectionOfAllVisibleRows() {
            const visibleIds = this.data.map((r) => r.id);
            const allVisibleRowsSelected = visibleIds && visibleIds.filter((id) => !this.selectedIds.includes(id)).length === 0;
            if (!allVisibleRowsSelected) {
                this.selectedIds = visibleIds;
            }
            else {
                this.selectedIds = [];
            }
        },
        toggleSelection(x) {
            if (this.selectedIds.includes(x)) {
                this.selectedIds = this.selectedIds.filter((r) => r !== x);
            }
            else {
                if (this.rowSelectionModePassedThroughProps === 'multiple') {
                    this.selectedIds.push(x);
                }
                else {
                    this.selectedIds = [x];
                }
            }
        },
        handleCellChange(e, cellProps) {
            return __awaiter(this, void 0, void 0, function* () {
                const { col, row } = cellProps;
                const field = col.sourceField ? col.sourceField(cellProps) : col.field;
                const oldDisplayVal = getDisplayValueFromEnrichedData(col, row);
                const oldVal = getValueFromEnrichedData(col, row);
                let newVal = '';
                newVal = (e && e.srcElement) ? String(e.srcElement.value) : e;
                if (oldDisplayVal === newVal)
                    return;
                if (String(newVal).endsWith('%') && (col.isNumeric || col.isPercent)) {
                    newVal = String(parseFloat(newVal.substring(0, newVal.length - 1)) / 100);
                }
                if (col.isPercent && Number(newVal) > 2)
                    newVal = String(Number(newVal) / 100);
                if (col.isInteger)
                    newVal = newVal.replace(/,/g, '');
                if (String(newVal).startsWith('$')) {
                    newVal = String(parseFloat(newVal.substring(1, newVal.length)));
                }
                if (newVal === oldVal)
                    return;
                const btfMap = col.backendToFronendValueMap;
                if (btfMap) {
                    for (const key in btfMap) {
                        if (btfMap[key] === newVal) {
                            newVal = key;
                            break;
                        }
                    }
                }
                // validation
                const currentRow = row;
                const projectedRow = Object.assign({}, currentRow);
                projectedRow[field] = col.transformInputToValue ? col.transformInputToValue(cellProps, newVal) : newVal;
                if (!rowIsValid(projectedRow, this.rowValidationRules, this))
                    return;
                if (col.encrypted)
                    newVal = encrypt(newVal);
                const rowId = row.id;
                if (this.dataPassedThroughProps) {
                    this.emitEvent('cell-change', { id: rowId, field, newVal });
                }
                else {
                    if (rowId) {
                        if (col.updateHandler) {
                            col.updateHandler(cellProps, newVal);
                        }
                        else {
                            const response = yield updateRecords(this.localEntityName, [{ id: rowId, [field]: newVal, source_table: col.source_table }]); // AK2020-08-13 'source_table' is used for updating extention tables from base table controllers.  Using 'source_table' the controller knows that it needs to update one of its extention tables as opposed to itself. E.g., to update ci.studios_extends_orgs from UI, we need to give its fields 'source_table' attribute = 'ci.studios_extends_orgs'.  'source_table' attribute is given in store: 'store/ci/studios.js'
                            if (response) {
                                if (this.fetchIntoLocalDataInsteadOfStorePassedThroughProps) {
                                    const data = response.data || [];
                                    if (response.totals)
                                        this.grandTotalsRow = response.totals;
                                    const localData = cloneDeep(this.localData || []);
                                    data.forEach(row => {
                                        const idx = localData === null || localData === void 0 ? void 0 : localData.findIndex(r => r.id === row.id);
                                        localData[idx] = row;
                                    });
                                    this.localData = localData;
                                }
                            }
                        }
                    }
                    else {
                        if (col.updateHandlerThatHandlesIdLessUpdates) {
                            col.updateHandlerThatHandlesIdLessUpdates(cellProps, newVal);
                        }
                        else {
                            this.createRecords([projectedRow]);
                        }
                    }
                }
            });
        },
        createRecord() {
            callRefFunc(this, 'create-new-record-tooltip', 'hide');
            let newRecord = {};
            this.columnsLocalCopy.filter((r) => !r.hideWhenCreating && r.field).forEach((col) => {
                if (this.filters) {
                    newRecord[col.field] = this.filters[col.field];
                }
            });
            for (const field in this.localFilterModel) {
                if (this.localFilterModel[field]['equals'] !== undefined) {
                    if (newRecord[field] === undefined)
                        newRecord[field] = this.localFilterModel[field]['equals'];
                }
            }
            if (this.applyToToBeCreatedRecord) {
                newRecord = this.applyToToBeCreatedRecord(newRecord, this);
            }
            if (this.initiationOfRecordCreationHandler) {
                this.initiationOfRecordCreationHandler(newRecord, this);
            }
            else if (this.createByAddingRow) {
                this.fillInDefaultValuesOfRecord(newRecord);
                this.createRecords([newRecord]);
            }
            else {
                const CreateRecordComponent = getEntityDefaultRecordCreateComponent(this.localEntityName);
                setCurrentMode({
                    component: CreateRecordComponent || RecordCard,
                    componentProps: {
                        ctx: this,
                        modeProp: 'createRecord',
                        localEntityNameProp: this.localEntityName
                    },
                    filters: this.filters
                });
            }
        },
        fetchRecords(fetchParams) {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield fetchRecords(this.localEntityName, fetchParams);
                if (response) {
                    if (this.fetchIntoLocalDataInsteadOfStorePassedThroughProps) {
                        if (fetchParams.onceFetchedApplyAsPartialRefresh) {
                            const data = response.data || [];
                            const localData = cloneDeep(this.localData || []);
                            data.forEach(row => {
                                const idx = localData === null || localData === void 0 ? void 0 : localData.findIndex(r => r.id === row.id);
                                if (idx > -1)
                                    localData[idx] = row;
                            });
                            this.localData = localData;
                        }
                        else {
                            this.localData = [...(response.data || []), ...(this.localData || [])];
                        }
                        if (response.totals)
                            this.grandTotalsRow = response.totals;
                    }
                }
                return response;
            });
        },
        createRecords(rows) {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield createRecords(`${this.localEntityName}`, rows);
                if (response) {
                    if (this.fetchIntoLocalDataInsteadOfStorePassedThroughProps) {
                        if (!Array.isArray(this.localData || []))
                            debugger;
                        this.localData = [...(response.data || []), ...(this.localData || [])];
                        if (response.totals)
                            this.grandTotalsRow = response.totals;
                    }
                }
            });
        },
        fillInDefaultValuesOfRecord(row) {
            // filling in default values if they exist, IN PLACE!
            for (const col of this.columnsSource) {
                if (col.defaultValueWhenCreating !== undefined && row[col.field] === undefined) {
                    row = Object.assign(Object.assign({}, row), { [col.field]: invokeOrIdentity(col.defaultValueWhenCreating) });
                }
            }
        },
        deleteRow(e, id) {
            return __awaiter(this, void 0, void 0, function* () {
                e.stopPropagation();
                if (this.localData)
                    this.localData = this.localData.filter(r => r.id !== id);
                const notify = () => {
                    this.$q.notify({ message: 'Record has been deleted', type: 'positive', progress: true });
                    this.emitEvent('record-deleted', id);
                };
                if (this.localEntityName) {
                    const response = yield Store.dispatch(`${this.localEntityName}/delete`, { id });
                    if (response)
                        notify();
                }
                else {
                    notify();
                }
            });
        },
        editRecord(e, id) {
            e.stopPropagation();
            setCurrentMode({
                component: RecordCard,
                componentProps: {
                    modeProp: 'editRecord', localEntityNameProp: this.localEntityName, idProp: id
                }
            });
        },
        atLeastOneValueInColumn(field) { return this.sourceData.some((r) => Boolean(r[field])); },
        rowClickHandler(evt, row) {
            this.isFullscreen = false;
            if (this.localEntityName) {
                try {
                    Store.dispatch(this.localEntityName + '/rowClickHandler', row);
                }
                catch (error) {
                    return false;
                }
            }
            return true;
        },
        rowClickHandler2(params) {
            const cellProps = { col: params.col, row: params.props.row };
            if (this.rowClickHandlerProp)
                this.rowClickHandlerProp(cellProps, params.e);
        },
        initialize() {
            return __awaiter(this, void 0, void 0, function* () {
                if (this.initializationInProcess === true)
                    return;
                this.initializationInProcess = true;
                this.localFilterModel = cloneDeep(this.startingFilterModelV0) || {};
                this.localSortingModel = cloneDeep(this.startingSortingModel) || [];
                this.paginationObject = this.paginationObject || { page_size: 10, page: 1 };
                if (this.initialRowsPerPage_effective) {
                    this.paginationObject.page_size = this.initialRowsPerPage_effective;
                }
                if (this.paginationObject.page_size !== undefined)
                    this.paginationObject = omit(this.paginationObject, 'rowsNumber');
                if (!this.dataPassedThroughProps && !this.isChildTablePassedThroughProps)
                    yield this.fetchData();
                this.initializationInProcess = false;
            });
        },
        getFetchDataParams(pageSize, page) {
            const filters = cloneDeep(deepmerge(deepmerge(transformSimpleFilterToFilterModelV0(this.filters), this.localFilterModel), transformFilterModelFromV1ToV0(this.permanentInvisibleToUserFilterModelProps || [])));
            for (const field in filters) {
                if ((filters[field] || {}).containedIn && Array.isArray((filters[field] || {}).containedIn)) {
                    filters[field].containedIn = filters[field].containedIn.filter((r) => String(r) !== '-999');
                }
            }
            let params = {};
            if (this.apiVersion === 1) {
                const filterConditions = transformFilterModelFromV0ToV1IfNotYet(filters);
                // cleaning up some edge cases
                for (const filterCondition of filterConditions) {
                    if (['containedIn'].includes(filterCondition.predicate)) {
                        const col = this.columnsSource.find(col => col.field === filterCondition.field);
                        if (col === null || col === void 0 ? void 0 : col.isArray) {
                            filterCondition.predicate = 'overlapsWith';
                        }
                    }
                }
                const pagination = {
                    count: this.paginationObject.count || -1,
                    page: page || this.paginationObject.page,
                    page_size: pageSize || this.paginationObject.page_size
                };
                const fetchPayloadV1 = {
                    filter_conditions: filterConditions,
                    sorting_model: (this.permanentSortingModelV1.length > 0) ? this.permanentSortingModelV1 : this.localSortingModel,
                    pagination,
                    preferred_view_type: 'list_view',
                    do_not_raise_error_on_missing_columns: true
                };
                if (this.fetchOnlyVisibleColumns === true) {
                    fetchPayloadV1.need_only_columns = this.visibleFields;
                    if (this.visibleFields.length === 0) {
                        console.warn('fetchOnlyVisibleColumns is true, but visibleFields length is 0');
                        return;
                    }
                }
                if (this.actionArgumentsPassedThroughProps !== null && this.actionArgumentsPassedThroughProps !== undefined) {
                    fetchPayloadV1['action_arguments'] = this.actionArgumentsPassedThroughProps || undefined;
                }
                params.payload = fetchPayloadV1;
            }
            else {
                params = Object.assign(Object.assign({}, (this.currentMode.fetchParams || {})), { filters, sorting: this.localSortingModel, page: page || this.paginationObject.page, page_size: pageSize || this.paginationObject.page_size });
            }
            if (this.fetchParamsToMixInPassedThroughProps) {
                params = deepmerge(this.fetchParamsToMixInPassedThroughProps, params);
            }
            return params;
        },
        fetchData_notDebounced(pageSize, page) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.localEntityName) {
                    console.warn('localEntityName is not set in fetchData_notDebounced');
                    return false;
                }
                // console.log('Entered fetchData_notDebounced')
                if (this.doNotFetchDataPassedThroughProps)
                    return true;
                this.loading = true;
                // console.log('fetchData_notDebounced 2')
                let params = this.getFetchDataParams(pageSize, page);
                // console.log('fetchData_notDebounced 3')
                params = Object.assign(Object.assign({}, params), { justReturnDataDontWriteToState: this.fetchIntoLocalDataInsteadOfStorePassedThroughProps });
                // console.log('fetchData_notDebounced 4')
                if (params === undefined)
                    return false;
                const response = yield fetchRecords(this.localEntityName, params);
                // console.log('fetchData_notDebounced 5')
                if (response) {
                    // console.log('fetchData_notDebounced 6')
                    if (params.justReturnDataDontWriteToState) {
                        this.localData = Array.isArray(response.data) ? response.data : [];
                    }
                    // console.log('fetchData_notDebounced 7')
                    if (response.totals)
                        this.grandTotalsRow = response.totals || {};
                    // console.log('fetchData_notDebounced 8')
                    this.loading = false;
                    this.remoteDistinctLabelsHolder = {};
                    // console.log('fetchData_notDebounced 9')
                    return true;
                }
                else {
                    return false;
                }
            });
        },
        fetchData(pageSize, page) {
            return __awaiter(this, void 0, void 0, function* () {
                // console.log('Entered fetchData')
                // This function gets debounced in created()
                return this.fetchData_notDebounced(pageSize, page);
            });
        }
    }
});
